<template>
  <div class="stepsdemo-content multisito-upload">
    <Toast :baseZIndex="10000" position="bottom-right" group="tc" />
    <Toast :baseZIndex="10000" position="bottom-right" group="failPrecheck" />
    <Toast :baseZIndex="10000" position="bottom-right" group="PrecheckKO" />
    <Toast :baseZIndex="10000" position="bottom-right" group="PrecheckOK" />
    <Card v-if="!loading">
      <template v-slot:title>
        <div class="grid"> 
          <p class="m-0 col-12 text-center">Carica Punti di Prelievo</p>
          <TutorialDialog :slides="slides" :window-size="windowSize" />
        </div>
      </template>
      <template v-slot:subtitle>
        <div v-if="activeTabIndex == 0">
          <p>
            Inserisci i dati del cliente e fornitura cliccando sul tasto +
          </p>
        </div>
        <div v-if="activeTabIndex == 1">
          <p>
            Scarica il template tramite il link a destra e poi ricaricalo compilato
          </p>
          <p style="color:rgba(0, 94, 255, 0.684)">
            <strong>
              Funzionalità in fase di sviluppo. É necessario scaricare e utilizzare sempre l'ultima versione del template.
            </strong>
          </p>
          <div class="container-fluid m-3 border">
            <p style="color:rgba(0, 94, 255, 0.684)">
              <strong>
                Compatibile con OpenOffice.
              </strong>
            </p>
            <a class="p-button p-button-primary" target="_blank" href="https://www.openoffice.org/it/download/">Scarica qui la versione completa</a>
          </div>
        </div>
      </template>
      
      <template v-slot:content>
        
        <div class="flex justify-content-between align-items-center">
          <div class="flex align-items-center" v-if="canChangeUploadView">
            <p class="m-0">Inserimento Avanzato</p>
            <InputSwitch v-model="checked_basic_view" @update:modelValue="changeViews($event)" class="m-3"/>
            <p class="m-0">Inserimento Lite</p>
          </div>
          <div>
            <Button label="Codici possibili dei distributori di Energia elettrica" :icon="`pi ${visibleCodDistributori ? 'pi-angle-down' : 'pi-angle-right'}`" iconPos="right" class="p-button-secondary" @click="openCodDistributori"/>
            <div  v-if="visibleCodDistributori">
              <div class="flex flex-wrap mb-3">
                <Chip :label="code" v-for="code in cod_distributori" :key="code"/>
              </div>
              <p style="font-size: 20px;">Valido: IT<span style="color:limegreen">001</span>...</p>
              <p style="font-size: 20px;">Non valido: IT<span style="color:orangered">000</span>...</p>
            </div>
          </div>
        </div>
        <div class="flex flex-column box-option m-2 customer-summary">
          <h3 class="m-0 col-12 flex justify-content-center" v-if="![3].includes(typeClient) && cliente">Dati cliente</h3>
          <div class="col-12 flex flex-wrap justify-content-between customer-summary-grid">
            <div class="box-option col-2 m-1 customer-summary-card" v-if="![3].includes(typeClient) && cliente">
              <label><strong>Anagrafica</strong></label>
              <p class="m-0">{{[2].includes(typeClient) ? `${cliente.cognome} ${cliente.nome}` : cliente.ragsoc}}</p>
              <p v-if="cliente.codfis" class="m-0"><strong>Codice fiscale:</strong> {{ cliente.codfis }}</p>
              <p v-if="cliente.piva" class="m-0"><strong>Partita IVA:</strong> {{ cliente.piva }}</p>
              <p v-if="cliente.codiceDestinatario" class="m-0"><strong>Codice SDI:</strong> {{ cliente.codiceDestinatario }}</p>
              <p v-if="cliente.codiceAteco" class="m-0"><strong>Codice ATECO:</strong> {{ cliente.codiceAteco }}</p>
            </div>
            <div class="box-option col-2 m-1 customer-summary-card" v-if="![3].includes(typeClient) && cliente">
              <label><strong>Indirizzo Legale</strong></label>
              <p class="m-0">{{ cliente.toponimo }} {{ cliente.indirizzo }}, {{ cliente.civico }} - {{ cliente.cap }} {{ cliente.nome_comune }}</p>
            </div>
            <div class="box-option col-2 m-1 customer-summary-card" v-if="![2].includes(typeClient) && rappresentante">
              <label><strong>Rappresentante: </strong></label>
              <p class="m-0">{{rappresentante.name || `${rappresentante.nome || ''} ${rappresentante.cognome || ''}`}}</p>
              <p class="m-0"><strong>Codice fiscale:</strong> {{rappresentante.codfis || rappresentante.cod_fiscale}}</p>
              <p v-if="getPecRappresentante().value" class="m-0">
                <strong>PEC:</strong>&nbsp;
                <span :class="{'p-error': getPecRappresentante().inherited}">
                  {{ getPecRappresentante().value }}
                  <template v-if="getPecRappresentante().inherited"> - La PEC sarà ereditata dal contatto</template>
                </span>
              </p>
            </div>
            <div class="box-option col-2 m-1 customer-summary-card" v-if="contatto">
              <label><strong>Contatto</strong></label>
              <p class="m-0"><strong>Indirizzo:</strong> {{ getContattoData('indirizzo') }}</p>
              <p class="m-0">
                <template v-for="(field) in getContattoData('indirizzo_digitale')" :key="field.label">
                  <p class="m-0"><strong>{{ field.label }}:</strong> {{ field.value }}</p>
                </template>
              </p>
            </div>
          </div>
        </div>
        <div class="flex align-items-start justify-content-evenly flex-wrap" v-if="views == 'basic'">
          <div class="col-12 lg:col-6 card p-2">
            <Button class="p-button-luce p-button-custom flex justify-content-center" @click="addRowForType('ee')" v-if="!row_ee.exist">
              <p style="font-size: xx-large;"><strong>Aggiungi un POD</strong> <i class="pi pi-plus"></i></p>
            </Button>
            <div v-else class="w-full p-button-custom" style="position:relative">
              <Button icon="pi pi-trash" class="p-button-text p-button-danger" style="position:absolute;right: 2%" @click="removeRowForType('ee')"/>
              <div class="flex justify-content-center col-12">
                <h4>Fornitura Luce <img class="icon-custom" alt="lightbulb icon" src="@/assets/img/lightbulb_120808.png"></h4>
              </div>
              <div class="col-12 flex flex-wrap">
                <div class="col-12 lg:col-6">
                  <label>Pod</label>
                  <InputMask class="w-full" mask="IT999E9999999*" placeholder="Inserisci POD" v-model="row_ee.code" @update:modelValue="removeError('ee', 'POD_PDR')"></InputMask>
                  <div v-show="validationRowErrors.ee.POD_PDR" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                  <div v-show="validationRowErrors.ee.POD_PDR_INVALID" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                  <div v-show="validationRowErrors.ee.POD_PDR_EXISTENT" class="p-error mt-1" style="font-size:11px">Già contrattualizzato</div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Iban</label>
                  <InputMask class="w-full text_toupper" mask="IT99a9999999999****99999*99" placeholder="Inserisci IBAN" v-model="row_ee.iban" @update:modelValue="removeError('ee', 'IBAN')"/>
                </div>
                <div class="col-12" v-if="row_ee.iban">
                  <div class="flex m-2 justify-content-center">
                    <Checkbox v-model="row_ee.checked_data_iban_equal_to_client" :binary="true" @change="setDatiIbanLite(row_ee, 'ee')"/>
                    <label class="ml-2">L'intestatario delle coordinate bancarie coincide con il cliente</label>
                  </div>
                  <div class="flex">
                    <div class="col-6">
                      <label>Intestatario</label>
                      <InputText v-model="row_ee.intestazione_iban" class="w-full" @update:modelValue="removeError('ee', 'INTESTAZIONE_IBAN')" :disabled="row_ee.checked_data_iban_equal_to_client"/>
                      <div v-show="validationRowErrors.ee.INTESTAZIONE_IBAN" class="p-error mt-1" style="font-size:11px">Intestazione iban necessaria</div>
                      <div v-show="validationRowErrors.ee.INTESTAZIONE_IBAN_INVALID" class="p-error mt-1" style="font-size:11px">Intestazione iban uguale a intestazione cliente</div>
                    </div>
                    <div class="col-6">
                      <label>Codice fiscale</label>
                      <InputMask v-model="row_ee.codice_fiscale_piva_iban" :mask="maskCFibanLite" class="text_toupper w-full" @update:modelValue="removeError('ee', 'CODICE_FISCALE_PIVA_IBAN')" :disabled="row_ee.checked_data_iban_equal_to_client"/>
                      <div v-show="validationRowErrors.ee.CODICE_FISCALE_PIVA_IBAN" class="p-error mt-1" style="font-size:11px">Codice fiscale iban necessario</div>
                      <div v-show="validationRowErrors.ee.CODICE_FISCALE_PIVA_IBAN_INVALID" class="p-error mt-1" style="font-size:11px">Codice fiscale iban uguale a codice fiscale cliente</div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Uso</label>
                  <Dropdown v-model="row_ee.uso" :options="usiEnergiaDomestico" placeholder="Seleziona USO" optionValue="name" optionLabel="name" class="w-full" @change="removeError('ee', 'USO')"></Dropdown>
                  <div v-show="validationRowErrors.ee.USO" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Offerta</label>
                  <Dropdown v-model="row_ee.offerta" :options="offerteEnergia" placeholder="Seleziona OFFERTA" optionValue="id" optionLabel="name" :filter="true" class="w-full" @change="removeError('ee', 'OFFERTA')"></Dropdown>
                  <div v-show="validationRowErrors.ee.OFFERTA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <!-- <div class="col-12 flex align-items-center" v-if="!isManualContract && isResidential">
                  <label>L'indirizzo di fornitura coincide con l'indirizzo dei residenza</label>
                  <Checkbox v-model="row_ee.addressEqual" :binary="true" class="m-3"/>
                </div> -->
                <div class="col-12 lg:col-6" v-if="!row_ee.addressEqual">
                  <label>Toponimo</label>
                  <InputText v-model="row_ee.toponimo" @input="(val) => (row_ee.toponimo = row_ee.toponimo.toUpperCase())" class="w-full" @update:modelValue="removeError('ee', 'TOPONIMO_FORNITURA')"></InputText>
                  <div v-show="validationRowErrors.ee.TOPONIMO_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>

                </div>
                <div class="col-12 lg:col-6" v-if="!row_ee.addressEqual">
                  <label>Indirizzo</label>
                  <InputText v-model="row_ee.indirizzo" @input="(val) => (row_ee.indirizzo = row_ee.indirizzo.toUpperCase())" class="w-full" @update:modelValue="removeError('ee', 'INDIRIZZO_FORNITURA')"></InputText>
                  <div v-show="validationRowErrors.ee.INDIRIZZO_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_ee.addressEqual">
                  <label>Civico</label>
                  <InputText v-model="row_ee.civico" @input="(val) => (row_ee.civico = row_ee.civico.toUpperCase())" class="w-full" @update:modelValue="removeError('ee', 'CIVICO_FORNITURA')"></InputText>
                  <div v-show="validationRowErrors.ee.CIVICO_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_ee.addressEqual">
                  <label>Cap</label>
                  <InputMask v-model="row_ee.cap" mask="99999" class="w-full" @update:modelValue="removeError('ee', 'CAP_FORNITURA')"></InputMask>
                  <div v-show="validationRowErrors.ee.CAP_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_ee.addressEqual">
                  <label>Provincia</label>
                  <Dropdown v-model="row_ee.provincia" class="w-full" :options="districts" placeholder="Seleziona PROVINCIA" :filter="true" optionLabel="name" optionValue="code" @change="onSelectedDistrictForType('ee', $event)" />
                  <div v-show="validationRowErrors.ee.SIGLA_PROVINCIA_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>

                </div>
                <div class="col-12 lg:col-6" v-if="!row_ee.addressEqual">
                  <label>Comune</label>
                  <Dropdown v-model="row_ee.nome_comune" :options="row_ee.citiesGrouped" placeholder="Seleziona COMUNE" :filter="true" optionLabel="name" optionValue="name" class="w-full"  @change="removeError('ee', 'CITTA_FORNITURA')"/>
                  <div v-show="validationRowErrors.ee.CITTA_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 lg:col-6 card p-2 flex justify-content-center align-items-center">
            <Button class="p-button-gas p-button-custom flex justify-content-center" @click="addRowForType('gas')" v-if="!row_gas.exist">
              <p style="font-size: xx-large;"><strong>Aggiungi un PDR</strong> <i class="pi pi-plus"></i></p>
            </Button>
            <div v-else class="w-full p-button-custom" style="position:relative">
              <Button icon="pi pi-trash" class="p-button-text p-button-danger" style="position:absolute;right: 2%" @click="removeRowForType('gas')"/>
              <div class="flex justify-content-center col-12">
                <h4>Fornitura Gas <img class="icon-custom" alt="fire icon" src="@/assets/img/gas_industry-48_44627.png"></h4>
              </div>
              <div class="col-12 flex flex-wrap">
                <div class="col-12 lg:col-6">
                  <label>Pdr</label>
                  <InputMask class="w-full" mask="99999999999999" placeholder="Inserisci PDR" v-model="row_gas.code" @update:modelValue="removeError('gas', 'POD_PDR')"></InputMask>
                  <div v-show="validationRowErrors.gas.POD_PDR" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                  <div v-show="validationRowErrors.gas.POD_PDR_INVALID" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                  <div v-show="validationRowErrors.gas.POD_PDR_EXISTENT" class="p-error mt-1" style="font-size:11px">Già contrattualizzato</div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Iban</label>
                  <InputMask class="w-full text_toupper" mask="IT99a9999999999****99999*99" placeholder="Inserisci IBAN" v-model="row_gas.iban" @update:modelValue="removeError('gas', 'IBAN')"/>
                </div>
                <div class="col-12" v-if="row_gas.iban">
                  <div class="flex m-2 justify-content-center">
                    <Checkbox v-model="row_gas.checked_data_iban_equal_to_client" :binary="true" @change="setDatiIbanLite(row_gas, 'gas')"/>
                    <label class="ml-2">L'intestatario delle coordinate bancarie coincide con il cliente</label>
                  </div>
                  <div class="flex">
                    <div class="col-6">
                      <label>Intestatario</label>
                      <InputText v-model="row_gas.intestazione_iban" class="w-full" @update:modelValue="removeError('gas', 'INTESTAZIONE_IBAN')" :disabled="row_gas.checked_data_iban_equal_to_client"/>
                      <div v-show="validationRowErrors.gas.INTESTAZIONE_IBAN" class="p-error mt-1" style="font-size:11px">Intestazione iban necessaria</div>
                      <div v-show="validationRowErrors.gas.INTESTAZIONE_IBAN_INVALID" class="p-error mt-1" style="font-size:11px">Intestazione iban uguale a intestazione cliente</div>

                    </div>
                    <div class="col-6">
                      <label>Codice fiscale</label>
                      <InputMask v-model="row_gas.codice_fiscale_piva_iban" :mask="maskCFibanLite" class="text_toupper w-full" @update:modelValue="removeError('gas', 'CODICE_FISCALE_PIVA_IBAN')" :disabled="row_gas.checked_data_iban_equal_to_client"/>
                      <div v-show="validationRowErrors.gas.CODICE_FISCALE_PIVA_IBAN" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                      <div v-show="validationRowErrors.gas.CODICE_FISCALE_PIVA_IBAN" class="p-error mt-1" style="font-size:11px">Codice fiscale iban uguale a codice fiscale cliente</div>
                    </div>
                  </div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Uso</label>
                  <Dropdown v-model="row_gas.uso" :options="usiGasDomestico" placeholder="Seleziona USO" optionValue="name" optionLabel="name" class="w-full" @change="removeError('gas', 'USO')"></Dropdown>
                  <div v-show="validationRowErrors.gas.USO" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Offerta</label>
                  <Dropdown v-model="row_gas.offerta" :options="offerteGas" placeholder="Seleziona OFFERTA" optionValue="id" optionLabel="name" :filter="true" class="w-full" @change="removeError('gas', 'OFFERTA')"></Dropdown>
                  <div v-show="validationRowErrors.gas.OFFERTA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 flex align-items-center">
                  <label>L'indirizzo di fornitura coincide con l'indirizzo dei residenza</label>
                  <Checkbox v-model="row_gas.addressEqual" :binary="true" class="m-3"/>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_gas.addressEqual">
                  <label>Toponimo</label>
                  <InputText v-model="row_gas.toponimo" @input="(val) => (row_gas.toponimo = row_gas.toponimo.toUpperCase())" class="w-full" @update:modelValue="removeError('gas', 'TOPONIMO_FORNITURA')"></InputText>
                  <div v-show="validationRowErrors.gas.TOPONIMO_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_gas.addressEqual">
                  <label>Indirizzo</label>
                  <InputText v-model="row_gas.indirizzo" @input="(val) => (row_gas.indirizzo = row_gas.indirizzo.toUpperCase())" class="w-full" @update:modelValue="removeError('gas', 'INDIRIZZO_FORNITURA')"></InputText>
                  <div v-show="validationRowErrors.gas.INDIRIZZO_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_gas.addressEqual">
                  <label>Civico</label>
                  <InputText v-model="row_gas.civico" @input="(val) => (row_gas.civico = row_gas.civico.toUpperCase())" class="w-full" @update:modelValue="removeError('gas', 'CIVICO_FORNITURA')"></InputText>
                  <div v-show="validationRowErrors.gas.CIVICO_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_gas.addressEqual">
                  <label>Cap</label>
                  <InputMask v-model="row_gas.cap" mask="99999" class="w-full" @change="removeError('gas', 'CAP_FORNITURA')"></InputMask>
                  <div v-show="validationRowErrors.gas.CAP_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_gas.addressEqual">
                  <label>Provincia</label>
                  <Dropdown v-model="row_gas.provincia" class="w-full" :options="districts" placeholder="Seleziona PROVINCIA" :filter="true" optionLabel="name" optionValue="code" @change="onSelectedDistrictForType('gas', $event)"/>
                  <div v-show="validationRowErrors.gas.SIGLA_PROVINCIA_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6" v-if="!row_gas.addressEqual">
                  <label>Comune</label>
                  <Dropdown v-model="row_gas.nome_comune" :options="row_gas.citiesGrouped" placeholder="Seleziona COMUNE" :filter="true" optionLabel="name" optionValue="name" class="w-full"  @change="removeError('gas', 'CITTA_FORNITURA')"/>
                  <div v-show="validationRowErrors.gas.CITTA_FORNITURA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6">
                  <label class="flex align-items-center" style="height: 34px;">Consumo annuo</label>
                  <InputNumber v-model="row_gas.consumo" inputId="integeronly" class="w-full" @update:modelValue="removeError('gas', 'CONSUMO_ANNUO')"/>
                  <div v-show="validationRowErrors.gas.CONSUMO_ANNUO" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6 flex flex-column justify-content-evenly">
                  <div class="flex justify-content-between align-items-center">
                    <p class="m-0 flex align-items-center gap-2">
                      Matricola
                      <i
                        v-if="isStrictGasMatricola"
                        class="ml-2 pi pi-question-circle text-orange-500 matricola-help-icon"
                        v-tooltip="'Dato obbligatorio: dato disponibile in fattura o sul contatore.'"
                      ></i>
                    </p>
                    <div v-if="!isStrictGasMatricola" class="flex m-2">
                      <label class="mr-2">NON IDENTIFICATA</label>
                      <Checkbox v-model="row_gas.checked_matricola_not_found" :binary="true" @change="setMatricola(row_gas)"/>
                    </div>
                  </div>
                  <InputText :disabled="!isStrictGasMatricola && row_gas.checked_matricola_not_found" v-model="row_gas.matricola" @input="(val) => (row_gas.matricola = row_gas.matricola.toUpperCase())" class="w-full" @update:modelValue="removeError('gas', 'MATRICOLA')"></InputText>
                  <div v-show="validationRowErrors.gas.MATRICOLA" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                  <div v-show="validationRowErrors.gas.MATRICOLA_INVALID" class="p-error mt-1" style="font-size:11px">Matricola non valida</div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Classe misuratore</label>
                  <Dropdown
                    v-model="row_gas.classe"
                    :options="classeOption"
                    placeholder="Seleziona CLASSE MISURATORE"
                    class="w-full"
                    @change="removeError('gas', 'CLASSE_MISURATORE')"
                    optionLabel="name"
                    dataKey="id"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value">
                        <div>{{slotProps.value.classe}}</div>
                      </div>
                    </template>
                    <template #option="slotProps">
                      <span>{{slotProps.option.classe}}</span>
                    </template>
                  </Dropdown>
                  <div v-show="validationRowErrors.gas.CLASSE_MISURATORE" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
                <div class="col-12 lg:col-6">
                  <label>Destinazione d'uso</label>
                  <Dropdown
                    v-model="row_gas.destinazione"
                    :options="destinazioneOption"
                    placeholder="Seleziona DESTINAZIONE D'USO"
                    class="w-full"
                    @change="removeError('gas', 'DESTINAZIONE_USO')"
                    optionLabel="name"
                    dataKey="id"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value">
                        <div>{{slotProps.value.name}}</div>
                      </div>
                    </template>
                    <template #option="slotProps">
                      <span>{{slotProps.option.name}}</span>
                    </template>
                  </Dropdown>
                  <div v-show="validationRowErrors.gas.DESTINAZIONE_USO" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <TabView v-model:activeIndex="activeTabIndex" class="stepUpload-multisito" v-if="views == 'advanced'">
          <TabPanel header="Upload Manuale">
            <div class="flex justify-content-end mx-2" v-if="manualRows.length > 0">
              <small @click="initManualRows" class="cursor-pointer"><p class="p-error">Elimina tutto ({{manualRows.length}})</p></small>
            </div>                
            <DataTable :value="manualRows" editMode="cell" @cell-edit-complete="onCellEditComplete" class="manual-rows-table" :class="{ 'manual-rows-table-sticky': responsiveLayout === 'scroll' }" :responsiveLayout="responsiveLayout" :breakpoint="breakpoint">
              <Column header="Azioni" :exportable="false" headerClass="row-actions-column" bodyClass="row-actions-column" style="min-width: 6rem; width: 6rem">
                <template #body="{ data, index }">
                  <div class="row-actions">
                    <Button v-if="canCloneRow(data, index)" icon="pi pi-copy" class="p-button-outlined row-action row-action-clone" v-tooltip="'Clona'" aria-label="Clona" @click.stop="cloneRow(data, index)" />
                    <Button icon="pi pi-trash" class="p-button-outlined p-button-danger row-action row-action-delete" v-tooltip="'Elimina'" aria-label="Elimina" @click.stop="deleteRow(data, index)" />
                  </div>
                </template>
              </Column>
              <template #empty>
                <div>Nessun dato</div>
              </template>
              <!-- <Column style="min-width: 10rem" v-if="prechecked">
                <template #body="{index}">
                  <div v-if="manualRows[index].PRECHECKOK" class="p-success mt-1">
                    Precheck OK
                  </div>
                  <div v-else class="p-error mt-1">
                    Ricontrolla i dati inseriti o procedi con <strong>{{ manualRows[index].COD_ESITO != '' && esiti_subentro.includes(manualRows[index].COD_ESITO) ? 'Subentro' : 'Voltura'}}</strong>
                  </div>
                </template>
              </Column> -->
              <Column v-for="header of headings" :key="header" :field="header" :header="header">
                <template #body="{ data, index }">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex text_toupper justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      {{data[header] == '' ? 'Inserisci...' : data[header]}}<br>
                      {{header == 'IBAN' && data[header] ? data['INTESTAZIONE_IBAN'] : ''}}<br>
                      {{header == 'IBAN' && data[header] ? data['CODICE_FISCALE_PIVA_IBAN'] : ''}}<br>
                    </div>
                    <div v-show="validationErrors[`${header}_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                    <div v-show="validationErrors[`${header}_duplicate_${index}`]" class="p-error mt-1" style="font-size:11px">Duplicato</div>
                    <div v-show="validationErrors[`${header}_contractualized_${index}`]" class="p-error mt-1" style="font-size:11px">Già contrattualizzato</div>
                    <div v-show="validationErrors[`${header}_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                    <div v-show="validationErrors[`${header}_precheck_${index}`]" class="p-error mt-1" style="font-size:11px">{{manualRows[index].DETTAGLIO_ESITO}}</div>
                    <div v-show="validationErrors[`${header}_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Codice sdi non valido</div>
                    <div v-if="header == 'IBAN'" v-show="validationErrors[`INTESTAZIONE_IBAN_${index}`]" class="p-error mt-1" style="font-size:11px">Intestazione iban necessaria</div>
                    <div v-if="header == 'IBAN'" v-show="validationErrors[`INTESTAZIONE_IBAN_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Intestazione iban uguale a intestazione cliente</div>
                    <div v-if="header == 'IBAN'" v-show="validationErrors[`CODICE_FISCALE_PIVA_IBAN_${index}`]" class="p-error mt-1" style="font-size:11px">Codice fiscale iban necessario</div>
                    <div v-if="header == 'IBAN'" v-show="validationErrors[`CODICE_FISCALE_PIVA_IBAN_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Codice fiscale iban uguale a codice fiscale cliente</div>
                  </div>
                </template>
                <template #editor="{ data, index }">
                  <InputText v-if="header == 'RAGIONE_SOCIALE'" v-model="data[header]" :id="`${header}_${index}`" autofocus @input="onInput($event, index, header)" :disabled="(typeClient != 3 || manualRows[index].PRECHECKOK) && data[header] != ''"/>

                  <InputMask v-if="header == 'CODICE_FISCALE_PIVA'" v-model="data[header]" :id="`${header}_${index}`" :mask="maskCF" :disabled="(typeClient != 3 || manualRows[index].PRECHECKOK) && data[header] != ''" class="text_toupper" @blur="onInput($event, index, header)"/>

                  <Dropdown v-if="header == 'CODICE_SDI'" v-model="data[header]" :options="sdi"  placeholder="Seleziona"  :filter="true" :showClear="true" optionLabel="sdi" optionValue="sdi" :disabled="manualRows[index].PRECHECKOK || typeClient == 2" @change="onSelectedSdi(index)"/>

                  <Button v-if="header == 'IBAN'" @click="toggle($event, 'dati_iban', data, index)" :label="(`${data.IBAN}` ? 'Modifica' : 'Aggiungi')+' IBAN'" type="button" icon="pi pi-pencil" iconPos="left" class="p-button-rounded p-button-info"/>

                  <InputMask class="text_toupper" v-if="header == 'POD_PDR'" v-model="data[header]" :id="`${header}_${index}`" autofocus :disabled="manualRows[index].PRECHECKOK" mask="**999*9999999*"/>

                  <Dropdown v-if="header == 'TOPONIMO_FORNITURA' && manualRows[index].POD_PDR != '' && isVisibleAddress(index)" v-model="data[header]" :options="toponimi" placeholder="Seleziona toponimo"  :filter="true" :showClear="true" optionLabel="name" optionValue="name" :id="`${header}_${index}`" @input="onInput($event, index, header)" :disabled="manualRows[index].PRECHECKOK"/>

                  <InputText v-if="!['RAGIONE_SOCIALE', 'CODICE_FISCALE_PIVA', 'CODICE_SDI', 'POD_PDR', 'IBAN','TOPONIMO_FORNITURA'].includes(header) && manualRows[index].POD_PDR != '' && isVisibleAddress(index)" v-model="data[header]" :id="`${header}_${index}`" @input="onInput($event, index, header)" :disabled="manualRows[index].PRECHECKOK"/>
                </template>
              </Column>
              <Column field="SIGLA_PROVINCIA_FORNITURA" header="SIGLA_PROVINCIA_FORNITURA" style="min-width: 8rem">
                <template #body="{data, index}">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <Dropdown 
                      v-if="manualRows[index].POD_PDR != '' && isVisibleAddress(index)"
                      v-model="data['SIGLA_PROVINCIA_FORNITURA']"
                      :options="districts" 
                      placeholder="Seleziona"
                      :filter="true"
                      optionLabel="name" optionValue="code"                    
                      @change="onSelectedDistrict(index, $event)"
                      :disabled="manualRows[index].PRECHECKOK"
                      />
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`SIGLA_PROVINCIA_FORNITURA_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`SIGLA_PROVINCIA_FORNITURA_IN_${index}`]" class="p-error mt-1" style="font-size:11px">Sigla della provincia inserita non riconosciuta</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="CITTA_FORNITURA" header="CITTA_FORNITURA" style="min-width: 8rem">
                <template #body="{data, index}">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <Dropdown 
                      v-if="manualRows[index].POD_PDR != '' && isVisibleAddress(index)"
                      v-model="data[`CITTA_FORNITURA`]" :options="citiesGrouped[index]" 
                      placeholder="Seleziona" 
                      :filter="true"
                      optionLabel="name" 
                      optionValue="name"
                      @change="onSelectedCity(index)"
                      :disabled="manualRows[index].PRECHECKOK"
                      />
                      
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`CITTA_FORNITURA_IN_${index}`]" class="p-error mt-1" style="font-size:11px">Città sconosciuta per la provincia selezionata</div>
                      <div v-show="validationErrors[`CITTA_FORNITURA_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Inserire una provincia valida per selezionare la città</div>
                      <div v-show="validationErrors[`CITTA_FORNITURA_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="USO" header="USO" style="min-width: 8rem">
                <template #body="{data, index}">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <Dropdown v-model="data['USO']" 
                      :options="usiOption[index]" 
                      placeholder="Seleziona Uso" 
                      @change="onSelectedUso(index, data)"
                      :disabled="manualRows[index].PRECHECKOK"
                      optionValue="name"
                      optionLabel="name"
                      >
                      <template #empty>
                        Inserisci un pod o un pdr
                      </template>
                    </Dropdown>
                  </div>
                  <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                    <div v-show="validationErrors[`USO_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                    <div v-show="validationErrors[`USO_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Campo non valido</div>
                  </div>
                </div>
              </template>
              </Column>
              <Column field="OFFERTA" header="OFFERTA" style="min-width: 8rem">
                <template #body="{data, index}">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <Dropdown v-model="data['OFFERTA']" :options="offerteOption[index]" placeholder="Seleziona Offerta" @change="onSelectedOfferta(index)"
                      :disabled="manualRows[index].PRECHECKOK"
                      optionValue="id"
                      optionLabel="name"
                      :filter="true">
                      <template #empty>
                        Inserisci un pod o un pdr
                      </template>
                    </Dropdown>
                  </div>
                  <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                    <div v-show="validationErrors[`OFFERTA_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                    <div v-show="validationErrors[`OFFERTA_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Seleziona un'offerta valida per la fornitura inserita</div>
                  </div>
                </div>
              </template>
              </Column>
              <Column field="CF_ATTIVAZIONE" header="CF PRECEDENTE INTESTATARIO" v-if="pratica == 'v'">
                <template #body="{data, index}">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <InputText v-model="data['CF_ATTIVAZIONE']" :id="`CF_ATTIVAZIONE_${index}`" @input="onInput($event, index, 'CF_ATTIVAZIONE')" :disabled="manualRows[index].PRECHECKOK" max-length="16"/>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`CF_ATTIVAZIONE_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`CF_ATTIVAZIONE_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                      <div v-show="validationErrors[`CF_PIVA_ATTIVAZIONE_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Almeno un campo tra CF e PIVA ATTIVAZIONE è necessario</div>
                      <div v-show="validationErrors[`CF_ATTIVAZIONE_equal_${index}`]" class="p-error mt-1" style="font-size:11px">CF ATTIVAZIONE non può essere uguale<br>al codice fiscale del cliente da attivare</div>

                    </div>
                  </div>
                </template>
              </Column>
              <Column field="PIVA_ATTIVAZIONE" header="PIVA PRECEDENTE INTESTATARIO" v-if="pratica == 'v'">
                <template #body="{data, index}">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <InputMask mask="99999999999" v-model="data['PIVA_ATTIVAZIONE']" :disabled="manualRows[index].PRECHECKOK" @update:modelValue="onInput($event, index, 'PIVA_ATTIVAZIONE')"/>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`PIVA_ATTIVAZIONE_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`PIVA_ATTIVAZIONE_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                      <div v-show="validationErrors[`PIVA_ATTIVAZIONE_equal_${index}`]" class="p-error mt-1" style="font-size:11px">PIVA ATTIVAZIONE non può essere uguale<br>alla partita iva del cliente da attivare</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column header="DATA_DECORRENZA" v-if="is_pratica">
                <template #body="{data, index}">
                  <div class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <Calendar v-model="data['DATA_DECORRENZA']" :numberOfMonths="2" :minDate="minDate" :manualInput="false" dateFormat="dd/mm/yy" showIcon @update:modelValue="onChangeDate($event, index)"/>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`DATA_DECORRENZA_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="STAGIONALITA_RICORRENTE" header="STAGIONALITÀ RICORRENTE" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['STAGIONALITA_RICORRENTE']" :options="stagionalitaOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK" optionValue="name" optionLabel="name"/>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="STAGIONALITA" header="STAGIONALITÀ" v-if="pratica == 's'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['STAGIONALITA']" :options="stagionalitaOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK" @change="onSelectedStagionalita($event, index)" optionValue="name" optionLabel="name"/>
                      <div v-if="data['STAGIONALITA'] == 'Si'">
                        <label>Fino a </label>
                        <Calendar v-model="data['DATA_STAGIONALITA']" dateFormat="dd/mm/yy" :minDate="minDataStagionalita"/>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="DISALIMENTABILE" header="DISALIMENTABILE" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['DISALIMENTABILE']" :options="stagionalitaOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK" @change="onSelectedDisalimentabile($event, index)" optionValue="name" optionLabel="name"/>
                      <div v-if="data['DISALIMENTABILE'] == 'No'">
                        <label>Motivazione</label>
                        <Dropdown v-model="data['MOTIVAZIONE_DISALIMENTABILE']" :options="motivazioniDisalimentabileOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK" optionValue="value" optionLabel="value"/>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="CONNESSIONE" header="CONNESSIONE" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['CONNESSIONE']" :options="connessioneOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK" @change="onSelectedConnessione($event, index)" optionValue="name" optionLabel="name"/>
                      <div v-if="data['CONNESSIONE'] == 'Temporanea'">
                        <label>Fino a </label>
                        <Calendar v-model="data['DATA_CONNESSIONE']" dateFormat="dd/mm/yy" :minDate="minDataStagionalita"/>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="USO_ENERGIA" header="USO ENERGIA" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['USO_ENERGIA']" :options="usoEnergiaApOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK"  optionValue="value" optionLabel="value"/>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="POTENZA_IMPEGNATA" header="POTENZA_IMPEGNATA" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['POTENZA_IMPEGNATA']" :options="potenzaOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK"  optionValue="value" optionLabel="value" @update:modelValue="onSelectedPotenza($event, index)" editable/>
                      <div v-if="data['POTENZA_SELEZIONATA'] && data['POTENZA_SELEZIONATA'].has_limit" class="flex align-items-center">
                        <label class="m-3">Limitatore</label>
                        <Checkbox v-model="data['POTENZA_SELEZIONATA'].checked" :binary="true" @update:modelValue="onChangeLimitatore($event, index)"></Checkbox>
                      </div>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`POTENZA_IMPEGNATA_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="POTENZA_DISPONIBILE" header="POTENZA_DISPONIBILE" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <InputNumber v-model="data['POTENZA_DISPONIBILE']" disabled/>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="TENSIONE" header="TENSIONE" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['TENSIONE']" :options="tensioneOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK"  optionValue="value" optionLabel="value"/>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="DICHIARAZIONE" header="DICHIARAZIONE" v-if="pratica == 'ap'">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pod' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div class="col-12 p-0">
                      <Dropdown v-model="data['DICHIARAZIONE']" :options="dichiarazioneOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK"  optionValue="value" optionLabel="value" @change="onSelectedDichiarazione($event, index)"/>
                      <Textarea v-model="data['DICHIARAZIONE_TEXT']" @update:modelValue="onChangeDichiarazione($event, index)" :placeholder="data['DICHIARAZIONE']" class="w-full"></Textarea>
                      <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                        <div v-show="validationErrors[`DICHIARAZIONE_TEXT_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                        <div v-show="validationErrors[`DICHIARAZIONE_TEXT_LENGTH_${index}`]" class="p-error mt-1" style="font-size:11px">Questa descrizione non può contenere più di 80 caratteri</div>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="TIPO_VOLTURA" header="TIPO VOLTURA" v-if="pratica == 'v'">
                <template #body="{data, index}">
                  <Dropdown v-model="data['TIPO_VOLTURA']" :options="volturaOption" placeholder="Seleziona" :disabled="manualRows[index].PRECHECKOK" optionValue="name" optionLabel="name"/>
                </template>
              </Column>
              <Column field="MATRICOLA">
                <template #header>
                  <span class="flex align-items-center gap-2">
                    MATRICOLA
                    <i
                      v-if="isStrictGasMatricola"
                      class="ml-2 pi pi-question-circle text-orange-500 matricola-help-icon"
                      v-tooltip="'Dato obbligatorio: dato disponibile in fattura o sul contatore.'"
                    ></i>
                  </span>
                </template>
                <template #body="{data, index}">
                  <div v-if="data.TIPO == 'pdr' && data.POD_PDR != ''" class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div style="width: 174px;">
                        <div v-if="!isStrictGasMatricola" class="flex m-2">
                          <Checkbox v-model="data.checked_matricola_not_found" :binary="true" @change="setMatricola(data, index)"/>
                          <label class="ml-2">NON IDENTIFICATA</label>
                        </div>
                        <inputText v-if="isStrictGasMatricola || !data.checked_matricola_not_found" class="m-2 w-full" v-model="data.MATRICOLA" @input="onInput($event, index, 'MATRICOLA')"/>
                      </div> 
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`MATRICOLA_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`MATRICOLA_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Matricola non valida</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="CLASSE_MISURATORE" header="CLASSE_MISURATORE">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pdr' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <Dropdown
                        v-model="data['CLASSE_MISURATORE']"
                        :options="classeOption"
                        placeholder="Seleziona"
                        :disabled="manualRows[index].PRECHECKOK"
                        @change="onSelectedClasse($event, index)"
                        optionLabel="name"
                        dataKey="id"
                      >
                        <template #value="slotProps">
                        <div v-if="slotProps.value">
                          <div>{{slotProps.value.classe}}</div>
                        </div>
                      </template>
                      <template #option="slotProps">
                        <span>{{slotProps.option.classe}}</span>
                      </template>
                    </Dropdown>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`CLASSE_MISURATORE_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`CLASSE_MISURATORE_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Campo errato</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="DESTINAZIONE_USO" header="DESTINAZIONE_USO">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pdr' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <Dropdown
                        v-model="data['DESTINAZIONE_USO']"
                        :options="destinazioneOption"
                        placeholder="Seleziona"
                        :disabled="manualRows[index].PRECHECKOK"
                        @change="onSelectedDestinazione(index)"
                        optionLabel="name"
                        dataKey="id"
                      >
                        <template #value="slotProps">
                          <div v-if="slotProps.value">
                            <div>{{slotProps.value.name}}</div>
                          </div>
                        </template>
                        <template #option="slotProps">
                          <span>{{slotProps.option.code}} - {{slotProps.option.name}}</span>
                        </template>
                      </Dropdown>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`DESTINAZIONE_USO_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`DESTINAZIONE_USO_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Campo errato</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="CONSUMO_ANNUO" header="CONSUMO_ANNUO">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pdr' && !manualRows[index].SUBENTRO && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <InputNumber v-model="data['CONSUMO_ANNUO']" inputId="integeronly" :disabled="manualRows[index].PRECHECKOK" @update:modelValue="onInput($event, index, 'CONSUMO_ANNUO')"/>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`CONSUMO_ANNUO_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="REMI" header="REMI" v-if="['s', 'ap'].includes(pratica)">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pdr' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <Dropdown v-model="data['REMI']" :options="remiOption[index]" placeholder="Seleziona Remi" @change="onSelectedRemi(index)" :disabled="manualRows[index].PRECHECKOK" optionValue="remi" optionLabel="remi"/>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`REMI_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`REMI_ERROR_${index}`]" class="p-error mt-1" style="font-size:11px">Codice Remi non valido</div>
                    </div>
                  </div>
                </template>
              </Column>
              <Column field="POTENZA_TERMICA" header="POTENZA_TERMICA" v-if="['ap'].includes(pratica)">
                <template #body="{data, index}">
                  <div v-if="manualRows[index].TIPO == 'pdr' && manualRows[index].POD_PDR != ''" class="flex flex-wrap">
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <InputNumber v-model="data['POTENZA_TERMICA']" inputId="integeronly" :disabled="manualRows[index].PRECHECKOK" @update:modelValue="onInput($event, index, 'POTENZA_TERMICA')"/>
                    </div>
                    <div :class="`col-12 p-0 flex justify-content-${windowSize <= 800 ? 'end' : 'start'}`">
                      <div v-show="validationErrors[`POTENZA_TERMICA_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                    </div>
                  </div>
                </template>
              </Column>

              <!-- <Column v-if="submitted" :exportable="false">
                <template #body="{ data, index }">
                  <div class="flex flex-nowrap">
                    <div v-if="esiti_subentro.includes(manualRows[index].COD_ESITO) && !manualRows[index].PRECHECKOK">
                      <div class="col-4 col-md-4">
                        <label class="ml-2"><strong>Subentro?</strong></label>
                        <div class="col-12 md:col-6 m-4 flex align-items-center">
                          <Checkbox v-model="data['SUBENTRO']" :binary="true" :disabled="manualRows[index].PRECHECKOK"/>
                        </div>
                      </div>
                    </div>
                    <div v-if="esiti_voltura.includes(manualRows[index].COD_ESITO) && !manualRows[index].PRECHECKOK">
                      <div class="col-4 col-md-4">
                        <label class="ml-2"><strong>Voltura?</strong></label>
                        <div class="col-12 md:col-6 m-4 flex align-items-center">
                          <Checkbox v-model="data['VOLTURA']" :binary="true" :disabled="manualRows[index].PRECHECKOK"/>
                        </div>
                      </div>
                    </div>
                    <div v-if="manualRows[index].VOLTURA && manualRows[index].PRECHECKOK">
                      <div class="col-4 col-md-4">
                        <p>IN VOLTURA</p>
                      </div>
                    </div>
                    <div v-if="manualRows[index].SUBENTRO && manualRows[index].PRECHECKOK">
                      <div class="col-4 col-md-4">
                        <p>IN SUBENTRO</p>
                      </div>
                    </div>
                    <div v-if="manualRows[index].VOLTURA && !manualRows[index].PRECHECKOK">
                      <label class="col-12 flex align-items-center" style="margin-left: 20px !important"><strong>CODICE FISCALE o PIVA PRECEDENTE</strong></label>
                      <div class="col-12 md:col-6 m-4 flex align-items-center">
                        <inputText v-model="data['CODICE_FISCALE_PIVA_PRECEDENTE']" @input="(val) => (data['CODICE_FISCALE_PIVA_PRECEDENTE'] = data['CODICE_FISCALE_PIVA_PRECEDENTE'].toUpperCase())" :binary="true" :disabled="manualRows[index].PRECHECKOK"/>  
                      </div>
                      <div v-show="validationErrors[`CODICE_FISCALE_PIVA_PRECEDENTE_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`CODICE_FISCALE_PIVA_PRECEDENTE_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                      <div v-show="validationErrors[`CODICE_FISCALE_PIVA_PRECEDENTE_precheck_${index}`]" class="p-error mt-1" style="font-size:11px">{{manualRows[index].DETTAGLIO_ESITO}}</div>
                    </div>
                    <div v-if="manualRows[index].SUBENTRO && !manualRows[index].PRECHECKOK && manualRows[index].TIPO == 'pdr'">
                      <label class="col-12 flex align-items-center" style="margin-left: 20px !important"><strong>CODICE REMI</strong></label>
                        <Dropdown v-model="data['REMI']" 
                        :options="remiOption[index]" 
                        optionLabel="remi"
                        optionValue="remi"
                        placeholder="Seleziona Remi" 
                        class="w-full"
                        :editable="true"
                        :disabled="manualRows[index].PRECHECKOK"
                        :filter="true"
                        >
                        <template #empty>
                          <div class="text-center">Inserisci il codice remi manualmente</div>
                        </template>
                        </Dropdown>
                      <div v-show="validationErrors[`REMI_${index}`]" class="p-error mt-1" style="font-size:11px">Campo necessario</div>
                      <div v-show="validationErrors[`REMI_INVALID_${index}`]" class="p-error mt-1" style="font-size:11px">Formato errato</div>
                      <div v-show="validationErrors[`REMI_NO_${index}`]" class="p-error mt-1" style="font-size:11px">Remi inesistente</div>
                    </div>
                  </div>
                </template>
              </Column> -->
              
            </DataTable>
            <OverlayPanel ref="dati_iban" @hide="hideOverlayDatiIban($event)">
              <div class="flex flex-column gap-3 w-25rem">
                <div class="flex align-items-center">
                  <label><strong>Iban</strong></label>
                  <InputMask
                    class="ml-2 text_toupper input-iban"
                    v-model="selectedRow.IBAN"
                    mask="IT99a9999999999****99999*99"
                    @blur="onInput($event, selectedIndex, 'IBAN')"
                  />
                </div>

                <div class="mt-3" v-if="selectedRow.IBAN != ''">
                  <div v-if="canChangeDatiIban" class="flex m-2">
                    <Checkbox v-model="selectedRow.checked_data_iban_equal_to_client" :binary="true" @change="setDatiIbanRow(selectedRow)"/>
                    <label class="ml-2">L'intestatario delle coordinate bancarie coincide con il cliente</label>
                  </div>
                  <div class="flex align-items-center">
                    <label><strong>Intestatario</strong></label>
                    <InputText
                      class="ml-2"
                      v-model="selectedRow.INTESTAZIONE_IBAN" 
                      @input="onInput($event, selectedIndex, 'INTESTAZIONE_IBAN')"
                      :disabled="selectedRow.checked_data_iban_equal_to_client"
                    />
                  </div>
                  <div class="flex align-items-center">
                    <label><strong>Codice fiscale</strong></label>
                    <InputMask
                      v-model="selectedRow.CODICE_FISCALE_PIVA_IBAN"
                      :mask="maskCFiban" class="ml-2 text_toupper"
                      @blur="onInput($event, selectedIndex, 'CODICE_FISCALE_PIVA_IBAN')"
                      :disabled="selectedRow.checked_data_iban_equal_to_client"
                    />
                  </div>

                </div>
              </div>
            </OverlayPanel>
              
            <div class="mt-2">
              <div class="flex justify-content-between">
                <div>
                  <Button class="btn-offerte" type="button" icon="pi pi-question-circle" v-tooltip="`Legenda`" @click="toggle($event, 'op')"/>
                  <OverlayPanel ref="op" id="legenda">
                    <div class="card font-size w-full">
                      <div v-for="field in fields" :key="field">
                        <span>{{ field.name }}</span> -
                        <span v-if="field.description.includes('Obbligatorio')">
                          <strong style="color: red">Obbligatorio</strong>
                        </span>
                        {{ field.description.replace('Obbligatorio', '')}}
                      </div>
                    </div>
                  </OverlayPanel>
                </div>
                
                <div>
                  <Button v-tooltip="`Aggiungi riga`" @click="addRow" icon="pi pi-plus" class="p-button-rounded p-button-success" />
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel header="Upload File">
            <div class="flex justify-content-end">
              <Button label="Scarica template da compilare" @click="downloadTemplate" class="p-button p-button-secondary" />
            </div>
            
            <div class="formgrid grid form-file">
              <div class="field col-12">
                <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(allowedType).join(', ')}} </div>
                <div class="button-wrapper">
                  <span :class="['label', {'active': fileToUpload.length > 0}]">
                    {{fileToUpload.length > 0 ? fileToUpload[0].name : 'Carica il template compilato qui' }}
                  </span>
                  <input id="upload" type="file" ref="file" :key="keyInputReset" @change="handleFileUpload( $event )" :accept="`${Object.values(allowedType).join(', ')}`" />
                </div>
                <div @click="removeFile" v-if="fileToUpload.length > 0" class="remove-file">rimuovi file</div>
                <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
              </div>
            </div>
            
          </TabPanel>
        </TabView>
      </template>
      <template v-slot:footer class="p-0">
        <div class="grid justify-content-between">
          <Button label="Indietro" @click="prevPage()" icon="pi pi-angle-left" iconPos="left" class="p-btn-footer card-primary btn-reset"/>
          <i></i>
          <Button label="Avanti" @click="nextPage()" v-if="canGoToNextPage" icon="pi pi-angle-right" iconPos="right" class="p-btn-footer card-primary btn-reset"/>  
          <Button label="Importa" @click="importRowsFileToTable()" v-if="activeTabIndex == 1 && fileToUpload.length > 0" icon="pi pi-angle-right" iconPos="right" class="p-btn-footer"/>  
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import TutorialDialog from './TutorialDialog.vue'
  import {ref, getCurrentInstance, onMounted, onActivated, nextTick, onUpdated, onUnmounted, computed, watch} from 'vue';
  import Service from '@/services/ask-pratiche/pratiche-wizard'
  import { useToast } from "primevue/usetoast";
  import moment from 'moment';
  import { useRoute, useRouter } from 'vue-router';
  import { useStore } from 'vuex';
  var XLSX = require("xlsx");
  import Opzioni from '@/config/opzioni'

  export default {
    components: {
      TutorialDialog
    },
    props: {
      formData: Object
    },
    emits: [
      'activeLoader', 
      'activeLoaderCaricamento', 
      'prev-page', 
      'next-page', 
      'complete'
    ],
    setup (props, {emit}) {
      const store = useStore()
      const isAdmin = computed(() => store.state.auth.user?.role === 'admin')
      const loading = ref(true)
      const route = useRoute()
      const toast = useToast();
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      const service = new Service(self.$eventBus)
      const opzioni = new Opzioni()
      const selectedRow = ref(null);
      const selectedIndex = ref(null);
      const headings = [
        'RAGIONE_SOCIALE',
        'CODICE_FISCALE_PIVA',
        'CODICE_SDI',
        'IBAN',
        'POD_PDR',
        'TOPONIMO_FORNITURA',
        'INDIRIZZO_FORNITURA',
        'CIVICO_FORNITURA',
        'CAP_FORNITURA',
      ]
      const fields = ref([])
      const validation_pod = ref([
        'RAGIONE_SOCIALE',
        'CODICE_FISCALE_PIVA',
        'POD_PDR',
        'TOPONIMO_FORNITURA',
        'INDIRIZZO_FORNITURA',
        'CIVICO_FORNITURA',
        'CAP_FORNITURA',       
        'SIGLA_PROVINCIA_FORNITURA',
        'CITTA_FORNITURA',
        'USO',
        'OFFERTA',
      ])
      const validation_pdr = ref([
        'RAGIONE_SOCIALE',
        'CODICE_FISCALE_PIVA',
        'POD_PDR',
        'TOPONIMO_FORNITURA',
        'INDIRIZZO_FORNITURA',
        'CIVICO_FORNITURA',
        'CAP_FORNITURA',       
        'SIGLA_PROVINCIA_FORNITURA',
        'CITTA_FORNITURA',
        'USO',
        'OFFERTA',
        'MATRICOLA',
        'CLASSE_MISURATORE',
        'DESTINAZIONE_USO',
        'CONSUMO_ANNUO'
      ])
      const manualRows = ref([])
      const editingRows = ref([]);
      const activeTabIndex = ref(0)
      let stepIndex = 2
      const fileToUpload = ref([])
      const offerte = ref([])
      const offerteOption = ref([])
      const offerteEnergia = ref([])
      const offerteGas = ref([])
      const allowedType = {
        'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
      const type_matrice = ref('');
      const matrice_id = ref('');
      const keyInputReset = ref(0)
      const validationErrors = ref({})
      const validationRowErrors = ref({
        ee:{
          RAGIONE_SOCIALE: false,
          CODICE_FISCALE_PIVA: false,
          POD_PDR: false,
          POD_PDR_EXISTENT: false,
          POD_PDR_INVALID: false,
          TOPONIMO_FORNITURA: false,
          INDIRIZZO_FORNITURA: false,
          CIVICO_FORNITURA: false,
          CAP_FORNITURA: false,       
          SIGLA_PROVINCIA_FORNITURA: false,
          CITTA_FORNITURA: false,
          USO: false,
          OFFERTA: false
        },
        gas:{
          RAGIONE_SOCIALE: false,
          CODICE_FISCALE_PIVA: false,
          POD_PDR: false,
          POD_PDR_INVALID: false,
          POD_PDR_EXISTENT: false,
          TOPONIMO_FORNITURA: false,
          INDIRIZZO_FORNITURA: false,
          CIVICO_FORNITURA: false,
          CAP_FORNITURA: false,       
          SIGLA_PROVINCIA_FORNITURA: false,
          CITTA_FORNITURA: false,
          USO: false,
          OFFERTA: false,
          MATRICOLA: false,
          MATRICOLA_INVALID: false,
          CLASSE_MISURATORE: false,
          DESTINAZIONE_USO: false,
          CONSUMO_ANNUO:false
        }
      })
      const submitted = ref(false)
      const showModal = ref(false)
      const cities = ref([])
      const sdi = ref([])
      const citiesGrouped = ref([])
      const toponimi = opzioni.toponimi
      const districts = opzioni.province
      const destinazioneOption = opzioni.categorieGas

      const usiOption = ref([])
      const remiOption = ref([])
      const totalRemi = ref([])
      const classeOption = opzioni.classiGas
      const stagionalitaOption = ref([
        {name: 'Si'},
        {name: 'No'}
      ])
      const connessioneOption = ref([
        {name: 'Permanente'},
        {name: 'Temporanea'}
      ])
      const motivazioniDisalimentabileOption = ref([
        {value: 'Presenti apparecchiature mediche per l\'esistenza in vita alimentare ad en. el.'},
        {value: 'Fornitura di pubblica utilità art. 18.1 c) Del. AEEG 04/08'}
      ])
      const volturaOption = ref([
        {name: 'Ordinaria'},
        {name: 'Mortis causa'}
      ])
      const minDataStagionalita = ref(new Date())
      const usiEnergia = ref([
        {id:1, name:'Illuminazione Pubblica'},
        {id:2, name:'Altri Usi'},
        {id:3, name:'Domestico residente'},
        {id:4, name:'Domestico non residente'},
      ]);
      const usiEnergiaDomestico = ref();
      const usiGas = ref([
        {id:2, name:'Altri Usi'},
        {id:4, name:'Domestico'}
      ])
      const usoEnergiaApOption = ref([])
      const usoEnergiaApOptionDefault = ref([
        { value: "Ordinaria" },
        { value: "Cottimo" },
        { value: "Installazione non presidiata in permanenza, situata fuori dagli abitati" },
        { value: "Impianto di illuminazione di monumenti e simili" },
        { value: "Impianto di risalita e simili" },
        { value: "Installazione mobili e precarie (roulottes e simili) situate fuori dai centri abitati o sprovviste della concessione di occupazione" },
        { value: "Singola costruzione non abitata in permanenza o comunque non di residenza anagrafica del proprietario (ville, case di caccia, etc)" },
        { value: "Costruzione che non sia raggiungibile con strada percorribile da automezzi o che sia separata dagli impianti di distribuzione o Cantiere" },
        { value: "Spettacolo viaggiante e simili" },
        { value: "Impianto realizzato in occasioni di manifestazioni e feste patronali, popolari, politiche, religiose, sportive, teatrali e simili" },
        { value: "Impianto relativo a riprese cinematografiche, televisive e simili" },
        { value: "Fornitura Temporanea diversa da cantiere con contributo non agevolato" },
        { value: "Insegne luminose e pubblicitarie" }
      ])
      const tensioneOption = ref([
        {value: 'BT monofase 220V'},
        {value: 'BT trifase 380V'},
        {value: 'MT'},
        {value: 'AT/AAT'}
      ])

      const dichiarazioneOption = ref([
        {value:'Condotta in locazione in uso per:'},
        {value:'Altre provenienze:'}
      ])
      const potenzaOption = ref([
        {value: 0.5, has_limit: false, checked: false},
        {value: 1, has_limit: false, checked: false},
        {value: 1.5, has_limit: false, checked: false},
        {value: 2, has_limit: false, checked: false},
        {value: 2.5, has_limit: false, checked: false},
        {value: 3, has_limit: false, checked: false},
        {value: 3.5, has_limit: false, checked: false},
        {value: 4, has_limit: false, checked: false},
        {value: 4.5, has_limit: false, checked: false},
        {value: 5, has_limit: false, checked: false},
        {value: 5.5, has_limit: false, checked: false},
        {value: 6, has_limit: false, checked: false},
        {value: 7, has_limit: false, checked: false},
        {value: 8, has_limit: false, checked: false},
        {value: 9, has_limit: false, checked: false},
        {value: 10, has_limit: false, checked: false},
        {value: 15, has_limit: false, checked: false},
        {value: 20, has_limit: true, checked: true},
        {value: 25, has_limit: true, checked: true},
        {value: 30, has_limit: true, checked: true}
      ])

      const possible_usiEnergia_for_typeClient = ref([
        {typeClient: 1, id_usi: [2]},
        {typeClient: 2, id_usi: [2,3,4]},
        {typeClient: 3, id_usi: [2]},
        {typeClient: 4, id_usi: [2]},
        {typeClient: 5, id_usi: [1,2]},
        {typeClient: 6, id_usi: [1,2]}
      ])

      const possible_usiGas_for_typeClient = ref([
        {typeClient: 1, id_usi: [2]},
        {typeClient: 2, id_usi: [4]},
        {typeClient: 3, id_usi: [2]},
        {typeClient: 4, id_usi: [2]},
        {typeClient: 5, id_usi: [2]},
        {typeClient: 6, id_usi: [2]}
      ])

      const usiGasDomestico = ref();

      const array_esito = ref([])
      const esiti_voltura = ref([
        '002','003','006','910', '103', '104', '107', '201'
      ])
      const esiti_subentro = ref([
        '004', '102'
      ])
      const esiti_noprecheck = ref([
        '005', '105', '106', '202', '203'
      ])
      const prechecked = ref(false)
      const op = ref();
      const slides = ref([])
      const typeClient = ref()
      const windowSize = ref(window.innerWidth)
      const breakpoint = ref('800px') 
      // const has_cf_attivazione = ref(false)  
      
      const maskCF = ref()
      const maskCFiban = ref()
      // const has_piva_attivazione = ref(true)
      const now = new Date()
      const minDate = ref(new Date(new Date(now).setDate(now.getDate() + 2)))
      const is_pratica = ref()
      const pratica = ref()

      const responsiveLayout = ref()
      const views = ref()
      const checked_basic_view = ref()
      const changeViews = (event, addItem = true) => {
        initManualRows()
        removeRowForType('ee')
        removeRowForType('gas')
        initValidationRowErrors() 

        if (event) {
          views.value = 'basic'
          if (addItem) addRowForType('ee')
        } else {
          views.value = 'advanced'
          if(addItem) addRow()
        }
        checked_basic_view.value = views.value == 'basic'
      }
      const cliente = ref()
      const contatto = ref()
      const rappresentante = ref()
      const hasValue = value => value !== null && value !== undefined && String(value).trim() !== ''
      const getPecRappresentante = () => {
        if (hasValue(rappresentante.value?.pec)) {
          return {value: rappresentante.value.pec, inherited: false}
        }
        if (hasValue(contatto.value?.pec)) {
          return {value: contatto.value.pec, inherited: true}
        }

        return {value: '', inherited: false}
      }
      const getContattoData = (type) => {
        const contact = contatto.value || {}

        if (type === 'indirizzo') {
          const via = [contact.toponimo, contact.indirizzo]
            .filter(hasValue)
            .join(' ')
          const viaConCivico = [via, contact.civico]
            .filter(hasValue)
            .join(', ')
          const localita = [contact.cap, contact.nome_comune]
            .filter(hasValue)
            .join(' ')

          return [viaConCivico, localita]
            .filter(hasValue)
            .join(' - ')
        }

        if (type === 'indirizzo_digitale') {
          const fields = [
            ['Email', contact.email],
            ['Cellulare', contact.cellulare || contact.cell],
            ['PEC', contact.pec]
          ]
          if(contact.bypass_pec?.value) fields.push(['Motivo del bypass', contact.bypass_pec.reason])

          return fields
            .filter(([, value]) => hasValue(value))
            .map(([label, value]) => ({label, value}))
        }

        return ''
      }
      const maskCFibanLite = 'aaaaaa99a99a9*9a'
      const row_ee = ref({
        exist:false,
        code:'',
        iban:'',
        intestazione_iban:'',
        codice_fiscale_piva_iban:'',
        checked_data_iban_equal_to_client: true,
        toponimo:'',
        indirizzo:'',
        civico:'',
        cap:'',
        provincia:'',
        comune:'',
        uso:'',
        offerta:null,
        addressEqual: true,
        citiesGrouped:[]
      })
      const row_gas = ref({
        exist:false,
        code:'',
        iban:'',
        intestazione_iban:'',
        codice_fiscale_piva_iban:'',
        checked_data_iban_equal_to_client: true,
        toponimo:'',
        indirizzo:'',
        civico:'',
        cap:'',
        provincia:'',
        comune:'',
        uso:'Domestico',
        offerta:null,
        addressEqual: true,
        citiesGrouped:[],
        matricola:'',
        classe:null,
        destinazione:null,
        consumo: 0,
        checked_matricola_not_found: false
      })
      const type_device_supply = {
        pod: 'ee',
        pdr: 'gas'
      }
      const visibleCodDistributori = ref(false)
      const initializedKey = ref(null)
      const initializing = ref(false)
      const responsiveInitialized = ref(false)

      const cod_distributori = ref(["001","002","003","004","005","006","007","008","009","010","011","012","013","014","015","016","017","018","019","020","021","022","023","024","025","026","027","028","029","030","031","032","033","034","035","036","037","038","039","040","041","042","043","044","045","046","047","048","049","050","053","055","056","057","058","059","060","062","063","064","065","066","067","070","071","072","074","075","077","079","080","081","082","083","085","086","087","089","090","091","092","094","096","098","099","100","101","102","103","105","106","107","108","109","110","111","112","116","117","118","120","122","124","125","126","127","128","129","130","131","132","133","134","135","136","137","138","139","140","141","142","145","146","148","149","151","152","153","154","155","157","158","159","161","162","163","164","165","221","222","250","251","252", "253", "610"])

      const dati_iban = ref()
      const toggle = async (event, type_op, data = null, index = null) => {        
        switch (type_op) {
          case 'dati_iban':
            selectedRow.value = data;
            selectedIndex.value = index
            setDatiIbanRow(data)
            dati_iban.value.toggle(event)
            break;
          case 'op':
            op.value.toggle(event);
            break;
        }
      }

      const hideOverlayDatiIban = (event = null) => {        
        if (event) {
          dati_iban.value.toggle(event);
        }
      }
      onUpdated(()=>{
        stepIndex = 2
      })

      const hasValidRouteId = computed(() => {
        return Boolean(route.params.id && route.params.id !== 'null' && route.params.id !== 'undefined')
      })
      const canChangeUploadView = computed(() => {
        return !is_pratica.value && typeClient.value == 2 && !hasValidRouteId.value
      })
      const isStepUploadRoute = () => route.path.startsWith('/multisito/step-upload')
      const hasValidFormData = () => {
        const typeClientFormData = props.formData?.typeClient
        const requiresCliente = ![3].includes(typeClientFormData)
        const requiresRappresentante = ![2].includes(typeClientFormData)

        return Boolean(
          props.formData &&
          Object.keys(props.formData).length > 0 &&
          typeClientFormData !== undefined &&
          (!requiresCliente || props.formData.cliente) &&
          props.formData.contatto &&
          (!requiresRappresentante || props.formData.rappresentante)
        )
      }
      const getInitializeKey = () => {
        if (!hasValidFormData()) return ''

        const clienteId = props.formData.cliente?.id || props.formData.cliente?.codfis || ''
        const contatto = props.formData.contatto || {}
        const contattoKey = [
          contatto.id || '',
          contatto.same_to_client ? 1 : 0,
          contatto.toponimo || '',
          contatto.indirizzo || '',
          contatto.civico || '',
          contatto.cap || '',
          contatto.provincia || '',
          contatto.cod_comune || contatto.comune || '',
          contatto.nome_comune || contatto.name || '',
          contatto.email || '',
          contatto.pec || '',
          contatto.cell || contatto.cellulare || ''
        ].join('|')
        const rappresentanteFormData = props.formData.rappresentante || {}
        const rappresentanteKey = [
          rappresentanteFormData.id || '',
          rappresentanteFormData.prev_id || '',
          rappresentanteFormData.codfis || '',
          rappresentanteFormData.name || '',
          rappresentanteFormData.nome || '',
          rappresentanteFormData.cognome || ''
        ].join('|')
        const offerteKey = (props.formData.offerte || []).map(offerta => offerta.id || offerta.name || '').join('|')

        return [
          route.params.id || 'new',
          props.formData.typeClient || '',
          clienteId,
          contattoKey,
          rappresentanteKey,
          props.formData.pratica || '',
          offerteKey
        ].join('::')
      }
      const resetDynamicOptions = () => {
        volturaOption.value = [
          {name: 'Ordinaria'},
          {name: 'Mortis causa'}
        ]
        usoEnergiaApOption.value = [...usoEnergiaApOptionDefault.value]
      }
      const syncFormData = () => {
        typeClient.value = props.formData.typeClient
        cliente.value = props.formData.cliente ? {...props.formData.cliente} : props.formData.cliente
        contatto.value = props.formData.contatto ? {...props.formData.contatto} : props.formData.contatto
        rappresentante.value = props.formData.rappresentante ? {...props.formData.rappresentante} : props.formData.rappresentante
        sdi.value = Array.isArray(props.formData.sdi) ? [...props.formData.sdi] : props.formData.sdi
      }
      const hasSavedManualRows = () => {
        return Array.isArray(props.formData?.manualRows) && props.formData.manualRows.length > 0
      }
      const resetStepUploadState = () => {
        minDataStagionalita.value = new Date(moment(new Date()).add(3, 'M'))
        usiEnergiaDomestico.value = usiEnergia.value.filter(uso => [3, 4].includes(uso.id))
        usiGasDomestico.value = usiGas.value.filter(uso => uso.id == 4)
        resetDynamicOptions()
        initManualRows()
        removeRowForType('ee')
        removeRowForType('gas')
        initValidationRowErrors()
        checked_basic_view.value = false
        views.value = undefined
        fileToUpload.value = []
        validationErrors.value = {}
        manualRows.value = []
        activeTabIndex.value = 0
        prechecked.value = false
      }
      const regexPod = /^IT\d{3}E\d{7}[\dA]$/
      const regexPdr = /^\d{14}$/
      const normalizeSupplyCode = (value) => String(value || '').trim().toUpperCase()
      const getSupplyTypeFromCode = (value, { allowIncompletePod = false } = {}) => {
        const normalizedValue = normalizeSupplyCode(value)

        if (regexPod.test(normalizedValue)) {
          return 'pod'
        }

        if (regexPdr.test(normalizedValue)) {
          return 'pdr'
        }

        if (allowIncompletePod && normalizedValue.startsWith('IT') && normalizedValue.length < 14) {
          return 'pod'
        }

        return null
      }
      const setManualRowOptions = (row, index) => {
        const podPdr = normalizeSupplyCode(row.POD_PDR)
        const rowType = podPdr ? getSupplyTypeFromCode(podPdr) : row.TIPO || null
        const isPod = rowType === 'pod'

        citiesGrouped.value[index] = row.SIGLA_PROVINCIA_FORNITURA
          ? opzioni.getCities(row.SIGLA_PROVINCIA_FORNITURA)
          : cities.value

        usiOption.value[index] = podPdr && rowType
          ? (isPod
            ? usiEnergia.value.filter(uso => getUsiForTypeClient('Energia').includes(uso.id))
            : usiGas.value.filter(uso => getUsiForTypeClient('Gas').includes(uso.id)))
          : []

        offerteOption.value[index] = podPdr && rowType
          ? (isPod ? offerteEnergia.value : offerteGas.value)
          : []

        if (rowType === 'pdr' && ['s', 'ap'].includes(pratica.value) && row.CITTA_FORNITURA) {
          getRemi(row.CITTA_FORNITURA, index)
        }
      }
      const isSameClientSupplyAddress = (row) => {
        if (!cliente.value) return false

        return [
          ['TOPONIMO_FORNITURA', 'toponimo'],
          ['INDIRIZZO_FORNITURA', 'indirizzo'],
          ['CIVICO_FORNITURA', 'civico'],
          ['CAP_FORNITURA', 'cap'],
          ['SIGLA_PROVINCIA_FORNITURA', 'provincia'],
          ['CITTA_FORNITURA', 'nome_comune']
        ].every(([rowKey, clienteKey]) => {
          return String(row[rowKey] || '').trim().toUpperCase() === String(cliente.value[clienteKey] || '').trim().toUpperCase()
        })
      }
      const getOptionFromList = (options, value, keys) => {
        if (!value || typeof value === 'object') return value || null

        return options.find(option => {
          return keys.some(key => String(option[key] || '').trim() === String(value || '').trim())
        }) || null
      }
      const restoreBasicRowFromManualRow = (row) => {
        const isPod = getSupplyTypeFromCode(row.POD_PDR) === 'pod'
        const type = isPod ? 'ee' : 'gas'
        const addressEqual = isSameClientSupplyAddress(row)
        const restoredRow = {
          exist: true,
          code: row.POD_PDR || '',
          iban: row.IBAN || '',
          intestazione_iban: row.INTESTAZIONE_IBAN || '',
          codice_fiscale_piva_iban: row.CODICE_FISCALE_PIVA_IBAN || '',
          checked_data_iban_equal_to_client: row.checked_data_iban_equal_to_client ?? true,
          toponimo: addressEqual ? '' : (row.TOPONIMO_FORNITURA || ''),
          indirizzo: addressEqual ? '' : (row.INDIRIZZO_FORNITURA || ''),
          civico: addressEqual ? '' : (row.CIVICO_FORNITURA || ''),
          cap: addressEqual ? '' : (row.CAP_FORNITURA || ''),
          provincia: addressEqual ? '' : (row.SIGLA_PROVINCIA_FORNITURA || ''),
          comune: '',
          nome_comune: addressEqual ? '' : (row.CITTA_FORNITURA || ''),
          uso: row.USO || (isPod ? '' : 'Domestico'),
          offerta: row.OFFERTA || null,
          addressEqual,
          citiesGrouped: row.SIGLA_PROVINCIA_FORNITURA ? opzioni.getCities(row.SIGLA_PROVINCIA_FORNITURA) : []
        }

        if (type === 'ee') {
          row_ee.value = restoredRow
          return
        }

        row_gas.value = {
          ...restoredRow,
          matricola: row.MATRICOLA || '',
          classe: getOptionFromList(classeOption, row.CLASSE_MISURATORE, ['id', 'classe']),
          destinazione: getOptionFromList(destinazioneOption, row.DESTINAZIONE_USO, ['id', 'name']),
          consumo: row.CONSUMO_ANNUO || 0,
          checked_matricola_not_found: Boolean(row.checked_matricola_not_found)
        }
      }
      const restoreBasicRowsFromFormData = () => {
        manualRows.value.forEach(row => {
          restoreBasicRowFromManualRow(row)
        })
      }
      const hasRestoredUploadViewState = () => {
        if (!hasSavedManualRows()) return false
        if (props.formData.view === 'basic') return row_ee.value.exist || row_gas.value.exist

        return manualRows.value.length > 0
      }
      const restoreManualRowsFromFormData = () => {
        if (!hasSavedManualRows()) return false

        manualRows.value = props.formData.manualRows.map(row => ({...row}))
        views.value = props.formData.view || 'advanced'
        checked_basic_view.value = views.value == 'basic'
        activeTabIndex.value = 0
        prechecked.value = manualRows.value.some(row => row.PRECHECKOK)
        manualRows.value.forEach((row, index) => {
          setManualRowOptions(row, index)
        })
        refreshIbanRowsFromCurrentData()
        if (views.value == 'basic') restoreBasicRowsFromFormData()

        return true
      }
      const initializeStepUpload = async () => {
        console.log(props.formData.contatto)
        if (!isStepUploadRoute()) return

        if (!hasValidFormData()) {
          loading.value = false
          emit("activeLoaderCaricamento", false)
          return
        }

        const initializeKey = getInitializeKey()
        if (
          initializing.value ||
          (initializedKey.value === initializeKey && !loading.value && (!hasSavedManualRows() || hasRestoredUploadViewState()))
        ) return

        initializing.value = true
        loading.value = true
        emit("activeLoaderCaricamento", true)

        try {
          resetStepUploadState()
          syncFormData()
          setIsPratica()
          minDataStagionalita.value = new Date(moment(minDataStagionalita.value).add(3, 'M'))

          if (!responsiveInitialized.value) {
            setResponsive()
            window.addEventListener('resize', () => {
              setResponsive()
            })
            responsiveInitialized.value = true
          }

          await getSlides()
          setMask()
          setMaskIban()
          setOfferte()
          getRemi()
          getHeadings()

          if ([1,4].includes(typeClient.value)) {
            if (!volturaOption.value.some(item => item.name === 'Incorporazione societaria')) {
              volturaOption.value.push({name: 'Incorporazione societaria'})
            }
          }

          if ([2].includes(typeClient.value)) {
            if (!usoEnergiaApOption.value.some(item => item.value === 'Ordinaria')) {
              usoEnergiaApOption.value.push({value: 'Ordinaria'})
            }
          } else {
            usoEnergiaApOption.value = [...usoEnergiaApOptionDefault.value]
          }

          if (hasValidRouteId.value) {
            await Promise.all([getDataMatrice()])
          } else {
            if (!restoreManualRowsFromFormData()) {
              changeViews(typeClient.value == 2 && !is_pratica.value, true)
            }
            emit("activeLoaderCaricamento", false)
            loading.value = false
          }

          initializedKey.value = initializeKey
        } finally {
          initializing.value = false
          if (loading.value) {
            emit("activeLoaderCaricamento", false)
            loading.value = false
          }
        }
      }

      onMounted(initializeStepUpload)
      onActivated(initializeStepUpload)
      watch(
        () => [route.path, getInitializeKey()],
        () => initializeStepUpload()
      )
      watch(
        () => props.formData?.rappresentante,
        (newRappresentante) => {
          rappresentante.value = newRappresentante ? {...newRappresentante} : newRappresentante
          refreshIbanRowsFromCurrentData()
        },
        { deep: true }
      )
      watch(
        () => props.formData?.contatto,
        (newContatto) => {
          contatto.value = newContatto ? {...newContatto} : newContatto
        },
        { deep: true }
      )


      const getDataMatrice = async () => {
        await service.getDataMatrice(stepIndex, route.params.id)
        .then((res)=>{
          if (!res.res.data.success) {
            toast.add({severity: 'warn', summary: 'Attenzione', detail: res.res.data.message});
            emit('complete')
          }else{
            changeViews(false, false)

            let data = res.res.data.data
            data.manualRows.forEach((row,index) => {
              addRow()
              Object.keys(row).forEach(key => {
                manualRows.value[index][key] = ['CONSUMO_ANNUO', 'POTENZA_DISPONIBILE', 'POTENZA_TERMICA'].includes(key) ? Number(row[key]) : row[key]
              })
              Object.keys(row).forEach(key => {
                if (headings.includes(key)) {
                  onCellEditComplete({field: key, index: index, restoringRow: true})
                }
              })
              setManualRowOptions(manualRows.value[index], index)
            })
          } 
        })
        .finally(()=>{
          emit("activeLoaderCaricamento", false)
          loading.value = false
        })
      }

      const getSlides = async () => {
        await service.getSlides(stepIndex)
        .then((res) => {
          slides.value = res.items
          slides.value.forEach(slide => {
            slide.name = `/images/Step/step${stepIndex}-${slide.order}.png`
          })
        })
      }


      const isVisibleAddress = (index)=>{
        let is_visible = false
        if (manualRows.value[index].POD_PDR != "" && manualRows.value[index].POD_PDR.length == 14) {
          is_visible = true
        }          
        return is_visible
      }

      const setResponsive = () => {
        windowSize.value = window.innerWidth
        responsiveLayout.value = windowSize.value > breakpoint.value.replace('px','') ? 'scroll' : 'stack'
      }
      // const setPiva_attivazione = () => {
      //   switch (typeClient.value) {
      //     case 3:
      //     case 2:
      //       has_piva_attivazione.value = false
      //       break;
      //   }
      // }
      // const setCf_attivazione = () => {
      //   switch (props.formData.pratica) {
      //     case 'v':
      //       has_cf_attivazione.value = true
      //       break;
      //   }
      // }
      const canChangeDatiIban = computed (() => {
        let allowed = [2]
        return allowed.includes(typeClient.value)
      })

      const normalizeMatricolaValue = (value) => {
        return String(value || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase()
          .replace(/[^A-Z0-9]+/g, ' ')
          .trim()
      }

      const isInvalidGasMatricola = (value) => {
        const normalized = normalizeMatricolaValue(value)
        const compact = normalized.replace(/\s+/g, '')
        const invalidExactValues = ['NO', 'NON', 'ND', 'NA', 'NAN', 'NULLO', 'NULL']
        const invalidPhrases = [
          'NON VALIDA',
          'NON VALIDO',
          'INVALIDA',
          'INVALIDO',
          'INVALID',
          'NON TROVATO',
          'NON TROVATA',
          'NOT FOUND',
          'INTROVABILE',
          'UNFINDABLE',
          'NON PERVENUTA',
          'NON PERVENUTO',
          'NON PRESENTE',
          'NON PRESENTE NELLA FATTURA',
          'NON PRESENTE IN FATT',
          'NOT PRESENT',
          'NOT AVAILABLE',
          'UNAVAILABLE',
          'MISSING',
          'ABSENT',
          'SCONOSCIUTA',
          'SCONOSCIUTO',
          'UNKNOWN',
          'IMPOSSIBILE',
          'IMPOSSIBLE',
          'NON ID',
          'NON IDENT',
          'NON IDENTI',
          'NON IDENTIFICATA',
          'NON IDENTIFICATO',
          'NON IDENTIFICABILE',
          'NON INDENTIFICATO',
          'NON INDENTIFICATA',
          'NON IDENIFICATA',
          'NON IDNETIFICAT',
          'NON IDNETIFICATA',
          'NON IDENTFICATO',
          'NON IDENTICATA',
          'NON IDENTIFICTA',
          'NON IDENTIFCATA',
          'NON IDENTIFIACATA',
          'NON IDENTIFICARA',
          'NON IDENTITIFICATA',
          'UNIDENTIFIED',
          'NOT IDENTIFIED'
        ]
        const compactInvalidPhrases = invalidPhrases.map((phrase) => phrase.replace(/\s+/g, ''))
        const invalidCompactPrefixes = [
          'NONV',
          'NONT',
          'NONP',
          'NONI',
          'INVA',
          'INTR',
          'INTRO',
          'SCON',
          'IMPO',
          'NOTF',
          'NOTP',
          'NOTA',
          'UNAV',
          'UNFI',
          'UNID',
          'MISS',
          'ABSE',
          'UNKN'
        ]

        return !normalized ||
          invalidExactValues.includes(compact) ||
          invalidPhrases.some((phrase) => normalized.includes(phrase)) ||
          compactInvalidPhrases.some((phrase) => compact.includes(phrase)) ||
          invalidCompactPrefixes.some((prefix) => compact.startsWith(prefix))
      }

      const isStrictGasMatricola = computed(() => ['s', 'ap'].includes(pratica.value))

      const setMatricola = (data, index = null) => {
        if (isStrictGasMatricola.value) return

        if (views.value == 'basic') {
          data.matricola = data.checked_matricola_not_found ? 'NON IDENTIFICATA' : ''
          if (data.matricola) {
            delete validationRowErrors.value.gas.MATRICOLA
            delete validationRowErrors.value.gas.MATRICOLA_INVALID
          }
        } else {
          data.MATRICOLA = data.checked_matricola_not_found ? 'NON IDENTIFICATA' : ''
          if (data.MATRICOLA && index !== null) {
            delete validationErrors.value[`MATRICOLA_${index}`]
            delete validationErrors.value[`MATRICOLA_INVALID_${index}`]
          }
        }
      }

      const canGoToNextPage = computed (()=>{
        let next = false
        if (views.value == 'advanced') {
          next = activeTabIndex.value == 0 && manualRows.value.length > 0
        }else{
          next = row_ee.value.exist || row_gas.value.exist
        }
        return next
      })
      const setMask = () => {
        switch (typeClient.value) {
          case 1:
          case 5:
          case 6:
          case 3:
            maskCF.value = '99999999999'
            break;
          case 2:
          case 4:
            maskCF.value = 'aaaaaa99a99a9*9a'
            break;
        }
      }
      const setMaskIban = () => {
        switch (typeClient.value) {
            case 2:
              maskCFiban.value = 'aaaaaa99a99a9*9a'
              break;

            case 3:
            case 5:
              maskCFiban.value = '99999999999'

              break;

            case 6:
              maskCFiban.value = props.formData.cliente.codfis.startsWith('0')
              ? 'aaaaaa99a99a9*9a'
              : '99999999999'

              break;

            default:
              maskCFiban.value = 'aaaaaa99a99a9*9a'
              break;
          }
      }

      const onInput = (e, index, field) => { 
        let value = typeof e == 'object' ? e.target.value : e        
        manualRows.value[index][field] = typeof value == 'number' ? value : value.toUpperCase()

        Object.keys(validationErrors.value).forEach(key => {
          if (key.startsWith(`${field}_`) && key.endsWith(`_${index}`)) {
            delete validationErrors.value[key];
          }
        })
      }

      onUpdated(() => {
        loading.value = false
      })
      const setIsPratica = () => {
        is_pratica.value = props.formData.pratica == null ? false : true
        pratica.value = props.formData.pratica
      }
      
      const setOfferte = () => {
        offerte.value = props.formData?.offerte || []

        if (offerte.value.length == 0) {
          emit('complete')
          return 
        }
        offerteEnergia.value = offerte.value.filter((offerta) => Number(offerta.tipologia) === 1)
        offerteGas.value = offerte.value.filter((offerta) => Number(offerta.tipologia) === 2)
      }


      const downloadTemplate = () => {
        emit("activeLoader", true)
        service.downloadTemplateMultisito(headings, props.formData.agente)
        .finally(() => {
          emit("activeLoader", false)
        })
      }

      const addRow = () => {
        if (manualRows.value.length >= 100) {
          toast.add({severity:'warn', summary:'Importazione fallita', detail: `Non è possibile inserire più di 100 punti di fornitura`});
          return;
        } else {
          let newRow = headings.reduce((obj, key) => ({...obj, [key]: ''}), {});
          citiesGrouped.value[manualRows.value.length] = cities.value
          newRow.TIPO = ''
          newRow.ID = 0
          newRow.INTESTAZIONE_IBAN = ''
          newRow.CODICE_FISCALE_PIVA_IBAN = ''
          newRow.checked_data_iban_equal_to_client = true

          newRow.SIGLA_PROVINCIA_FORNITURA = null
          newRow.CITTA_FORNITURA = null

          if (typeClient.value != 3) {
            newRow.RAGIONE_SOCIALE = typeClient.value == 2 ? `${props.formData.cliente.nome} ${props.formData.cliente.cognome}` : props.formData.cliente.ragsoc
            newRow.CODICE_FISCALE_PIVA = props.formData.cliente.codfis != '' ? props.formData.cliente.codfis : props.formData.cliente.piva
            newRow.CODICE_SDI = props.formData.cliente.codiceDestinatario
          }else{
            newRow.ID_CLIENTE = 0
          }
          if (is_pratica.value) {
            newRow.DATA_DECORRENZA = minDate.value
            if (['s'].includes(pratica.value)) {
              newRow.STAGIONALITA = 'No'
            }
            if (['ap'].includes(pratica.value)) {
              newRow.STAGIONALITA_RICORRENTE = 'No'
              newRow.DISALIMENTABILE = 'Si'
              newRow.CONNESSIONE = 'Permanente'
              newRow.USO_ENERGIA = 'Ordinaria'
              newRow.DICHIARAZIONE = 'Condotta in locazione in uso per:'
              newRow.POTENZA_IMPEGNATA = 0
              newRow.POTENZA_SELEZIONATA = null
              if ([2].includes(typeClient.value)) {
                newRow.TENSIONE = tensioneOption.value[0].value
              }else{
                newRow.TENSIONE = tensioneOption.value[1].value
              }
            }
            if (['v'].includes(pratica.value)) {
              newRow.TIPO_VOLTURA = 'Ordinaria'
            }
          }
          manualRows.value.push(newRow)          
        }
      }

      const canCloneRow = (row, index) => {
        if (typeClient.value !== 3 || !getSupplyTypeFromCode(row.POD_PDR)) return false
        const required = [...(row.TIPO === 'pod' ? validation_pod.value : validation_pdr.value), 'CODICE_SDI']
        if (pratica.value != null) required.push('DATA_DECORRENZA')
        if (pratica.value === 'v') required.push('CF_ATTIVAZIONE')
        if (row.TIPO === 'pdr' && ['s', 'ap'].includes(pratica.value)) required.push('REMI')
        if (pratica.value === 'ap') {
          required.push(...(row.TIPO === 'pod' ? ['DICHIARAZIONE_TEXT', 'POTENZA_IMPEGNATA'] : ['POTENZA_TERMICA']))
        }
        if (row.IBAN) required.push('INTESTAZIONE_IBAN', 'CODICE_FISCALE_PIVA_IBAN')
        return required.every(field => row[field] != null && String(row[field]).trim() !== '')
          && !Object.keys(validationErrors.value).some(key => key.endsWith(`_${index}`) && validationErrors.value[key])
      }
      const copyRowData = (value) => {
        if (value instanceof Date) return new Date(value.getTime())
        if (Array.isArray(value)) return value.map(copyRowData)
        if (value && typeof value === 'object') {
          return Object.keys(value).reduce((copy, key) => {
            copy[key] = copyRowData(value[key])
            return copy
          }, {})
        }
        return value
      }
      const cloneRow = (row, index) => {
        if (!canCloneRow(row, index)) return
        const newIndex = manualRows.value.length
        addRow()
        if (manualRows.value.length === newIndex) return
        const clonedRow = copyRowData(row)
        clonedRow.POD_PDR = ''
        clonedRow.ID = 0
        clonedRow.ID_CLIENTE = 0
        clonedRow.PRECHECKOK = false
        clonedRow.COD_ESITO = ''
        clonedRow.DETTAGLIO_ESITO = ''
        delete clonedRow.DATA_DECORRENZA_FORMATTED
        delete clonedRow.DATA_CONNESSIONE_FORMATTED
        manualRows.value[newIndex] = clonedRow
        setManualRowOptions(clonedRow, newIndex)
      }

      const addRowForType = async (type) => {
        if (type == 'ee') {
          row_ee.value.exist = true
          if (offerteEnergia.value.length == 1) {
            row_ee.value.offerta = offerteEnergia.value[0].id 
          }
          setDatiIbanLite(row_ee.value, type)
        }
        if (type == 'gas'){
          row_gas.value.exist = true
          if (offerteGas.value.length == 1) {
            row_gas.value.offerta = offerteGas.value[0].id
          }
          setDatiIbanLite(row_gas.value, type)
        }
      }
      const initManualRows = () => {
        manualRows.value = []
        validationErrors.value = {}
        usiOption.value = []
        remiOption.value = []
        offerteOption.value = []
        prechecked.value = false
      }

      const removeRowForType = (type) => {
        if (type == 'ee') {
          row_ee.value = {
            exist:false,
            code:'',
            iban:'',
            intestazione_iban:'',
            codice_fiscale_piva_iban:'',
            checked_data_iban_equal_to_client: true,
            toponimo:'',
            indirizzo:'',
            civico:'',
            cap:'',
            provincia:'',
            comune:'',
            uso:'',
            offerta:null,
            addressEqual: true,
            citiesGrouped:[]
          }
        }else{
          row_gas.value = {
            exist:false,
            code:'',
            iban:'',
            intestazione_iban:'',
            codice_fiscale_piva_iban:'',
            checked_data_iban_equal_to_client: true,
            toponimo:'',
            indirizzo:'',
            civico:'',
            cap:'',
            provincia:'',
            comune:'',
            uso:'',
            offerta:null,
            addressEqual: true,
            citiesGrouped:[],
            matricola:'',
            classe:null,
            destinazione:null,
            consumo: 0,
            checked_matricola_not_found: false
          }
        }
      }
      const deleteRow = (row, index) => {
        manualRows.value.splice(index, 1);
        offerteOption.value.splice(index, 1)
        usiOption.value.splice(index, 1)
        validationErrors.value = []
        let properties = [
          'SIGLA_PROVINCIA_FORNITURA',
          'CITTA_FORNITURA',
          'USO',
          'OFFERTA'
        ] 
        let possibleDistricts = []
        cities.value.forEach(element => {
          possibleDistricts.push(element.provincia)
        });
        manualRows.value.forEach((row, i) => {
          let possibleCities = []
          let evt = {}
          evt.value = null
          let campo = null

          properties.forEach((proprieta) => {
            if (proprieta in row) {
              campo = row[proprieta]
              switch (proprieta) {
                case 'SIGLA_PROVINCIA_FORNITURA':
                  if (campo) {
                    if (!possibleDistricts.includes(campo)) {
                      validationErrors.value[`${proprieta}_IN_${i}`] = true
                    }else{
                      evt.value = campo
                      cities.value.forEach(element => {
                        if (element.provincia == campo) {
                          possibleCities.push(element.name)
                        }
                      });
                    }
                  }else{
                    validationErrors.value[`${proprieta}_${i}`] = true
                  }
                  onSelectedDistrict(i, evt)
                  break;
                  case 'CITTA_FORNITURA':
                    if (campo) {
                      if (validationErrors.value[`SIGLA_PROVINCIA_FORNITURA_${i}`]) {
                        onSelectedDistrict(i, evt)
                        validationErrors.value[`${proprieta}_NO_${i}`] = true
                      }else if (!possibleCities.includes(campo)) {
                        validationErrors.value[`${proprieta}_IN_${i}`] = true
                      }
                    }else{
                      validationErrors.value[`${proprieta}_${i}`] = true
                    }
                    
                    break;
                    case 'USO':
                    case 'OFFERTA':
                      if (!campo) {
                        validationErrors.value[`${proprieta}_${i}`] = true
                      }
                      break;
              }                                      
            }else{
              validationErrors.value[`${proprieta}_${i}`] = true
            }
          })
        });
      }
      const handleFileUpload = async (evt) => {
        fileToUpload.value = []
        evt.preventDefault()
        submitted.value = false;
        fileToUpload.value = self.refs.file.files
      }
      // const getDistricts = () => {
      //   service.getDistricts().then((res) => {
      //     districts.value = res.items
      //   })
      // }
      const onSelectedDistrict = (i, evt = null) => {
        if (evt.value) {
          citiesGrouped.value[i] = opzioni.getCities(evt.value)
        }else{
          citiesGrouped.value[i] = cities.value
        }
        manualRows.value[i].CITTA_FORNITURA = null
        delete validationErrors.value[`SIGLA_PROVINCIA_FORNITURA_${i}`];
        delete validationErrors.value[`SIGLA_PROVINCIA_FORNITURA_IN_${i}`];          
        delete validationErrors.value[`CITTA_FORNITURA_${i}`];          
        delete validationErrors.value[`CITTA_FORNITURA_NO_${i}`];          
        delete validationErrors.value[`CITTA_FORNITURA_IN_${i}`];          
      }
      const onSelectedDistrictForType = async (type, evt = null) => {        
        eval(`row_${type}`).value.citiesGrouped = opzioni.getCities(evt.value)
        removeError(type, 'SIGLA_PROVINCIA_FORNITURA')      
      }
      const removeError = (type, input) => {
        validationRowErrors.value[type][input] = false
        if (input == 'POD_PDR') {
          validationRowErrors.value[type][`${input}_EXISTENT`] = false
          validationRowErrors.value[type][`${input}_INVALID`] = false
        }
        if (input == 'MATRICOLA') {
          validationRowErrors.value[type][`${input}_INVALID`] = false
        }
        if (['INTESTAZIONE_IBAN', 'CODICE_FISCALE_PIVA_IBAN'].includes(input)) {
          validationRowErrors.value[type][`${input}_INVALID`] = false
        }
        if (['IBAN'].includes(input)) {
          validationRowErrors.value[type][`INTESTAZIONE_IBAN_INVALID`] = false
          validationRowErrors.value[type][`CODICE_FISCALE_PIVA_IBAN_INVALID`] = false

          validationRowErrors.value[type][`INTESTAZIONE_IBAN`] = false
          validationRowErrors.value[type][`CODICE_FISCALE_PIVA_IBAN`] = false
        }
        if (type == 'ee' && input == 'USO') {
          row_ee.value.addressEqual = row_ee.value.uso == usiEnergiaDomestico.value[0].name
        }
      }
      const onSelectedCity = (i) => {
        delete validationErrors.value[`CITTA_FORNITURA_${i}`];
        delete validationErrors.value[`CITTA_FORNITURA_IN_${i}`];
        delete validationErrors.value[`CITTA_FORNITURA_NO_${i}`];
        if(manualRows.value[i].TIPO == 'pdr' && ['s', 'ap'].includes(pratica.value)){
          delete remiOption.value[i]
          getRemi(manualRows.value[i].CITTA_FORNITURA, i)
        }
      }
      const onSelectedClasse = (evt,i) => {
        if (pratica.value == 'ap') {
          manualRows.value[i].POTENZA_TERMICA = evt.value.portata_termica
          delete validationErrors.value[`POTENZA_TERMICA_${i}`];
        }
        
        delete validationErrors.value[`CLASSE_MISURATORE_${i}`];
        delete validationErrors.value[`CLASSE_MISURATORE_NO_${i}`];
      }
      const onSelectedStagionalita = (evt, i) => {
        delete validationErrors.value[`STAGIONALITA_${i}`];
        if (evt.value == 'Si') {
          if (!('DATA_STAGIONALITA' in manualRows.value[i])) {
            manualRows.value[i].DATA_STAGIONALITA = minDataStagionalita.value
          }
        }
      }
      const onSelectedConnessione = (evt, i) => {
        delete validationErrors.value[`CONNESSIONE_${i}`];
        if (evt.value == 'Temporanea') {
          if (!('DATA_CONNESSIONE' in manualRows.value[i])) {
            manualRows.value[i].DATA_CONNESSIONE = minDataStagionalita.value
          }
        }
      }
      const onSelectedPotenza = (evt, i) => {
        manualRows.value[i].POTENZA_DISPONIBILE = 0
        evt = Number(evt)
        delete validationErrors.value[`POTENZA_IMPEGNATA_${i}`];
        if (manualRows.value[i].POTENZA_SELEZIONATA) {
          let index_potenza = potenzaOption.value.findIndex(potenza => potenza.value == manualRows.value[i].POTENZA_SELEZIONATA.value)
          if (potenzaOption.value[index_potenza].has_limit) {
            potenzaOption.value[index_potenza].checked = true            
          }
        }

        let index_evt = potenzaOption.value.findIndex(potenza => potenza.value == evt)
        if (index_evt == -1) {
          if (evt > 30) {
            manualRows.value[i].POTENZA_DISPONIBILE = evt
          } else {
            manualRows.value[i].POTENZA_IMPEGNATA = 0
            manualRows.value[i].POTENZA_DISPONIBILE = 0
          }
        } else {
          manualRows.value[i].POTENZA_SELEZIONATA = potenzaOption.value[index_evt]
          manualRows.value[i].POTENZA_DISPONIBILE = evt >= 17 ? evt : (evt+(evt*0.1))   
        }
        
        let index = 3
        if (evt <= 6) {
          index = 0
        } else if(evt <= 250){
          index = 1  
        }else if(evt <= 10000){
          index = 2
        }
        manualRows.value[i].TENSIONE = tensioneOption.value[index].value
      }
      const onSelectedDisalimentabile = (evt, i) => {
        delete validationErrors.value[`DISALIMENTABILE_${i}`];
        if (evt.value == 'No') {          
          if (!('MOTIVAZIONE_DISALIMENTABILE' in manualRows.value[i])) {
            manualRows.value[i].MOTIVAZIONE_DISALIMENTABILE = 'Presenti apparecchiature mediche per l\'esistenza in vita alimentare ad en. el.'
          }
        }
      }
      const onChangeDichiarazione = (evt, i) => {        
        manualRows.value[i].DICHIARAZIONE_TEXT = evt.replaceAll(`${manualRows.value[i].DICHIARAZIONE} `,'') == '' ? evt.replaceAll(`${manualRows.value[i].DICHIARAZIONE} `,'') : (manualRows.value[i].DICHIARAZIONE + ' ' + evt.replaceAll(`${manualRows.value[i].DICHIARAZIONE} `,''))
        delete validationErrors.value[`DICHIARAZIONE_TEXT_${i}`];
        delete validationErrors.value[`DICHIARAZIONE_TEXT_LENGTH_${i}`];
      }
      const onSelectedDichiarazione = (evt, i) => {
        manualRows.value[i].DICHIARAZIONE_TEXT = ''
      }
      const onSelectedDestinazione = (i) => {
        delete validationErrors.value[`DESTINAZIONE_USO_${i}`];
        delete validationErrors.value[`DESTINAZIONE_USO_NO_${i}`];
      }
      const onSelectedSdi = (i) => {
        delete validationErrors.value[`CODICE_SDI_${i}`];
        delete validationErrors.value[`CODICE_SDI_NO_${i}`];
      }
      const onSelectedOfferta = (i) => {        
        delete validationErrors.value[`OFFERTA_${i}`];
        delete validationErrors.value[`OFFERTA_NO_${i}`];
      }
      const onSelectedUso = (i, data) => {
        delete validationErrors.value[`USO_${i}`];
        delete validationErrors.value[`USO_NO_${i}`];
        if (['ap'].includes(pratica.value)) {
          const regex = /^Domestico/;
          usoEnergiaApOption.value = []
          usoEnergiaApOption.value = regex.test(data.USO) ? [{value: 'Ordinaria'}] : [...usoEnergiaApOptionDefault.value]
          data.USO_ENERGIA = 'Ordinaria'
        }
      }
      const onSelectedRemi = (i) => {
        delete validationErrors.value[`REMI_${i}`];
      }
      const getCities = (set_client = false) => {
        cities.value = opzioni.getCities()
        if (set_client) {
          cliente.value = props.formData.cliente
          cliente.value.nome_comune = cities.value.find(city => city.id == cliente.value.comune_legale).name
        }         
      }
      const getSDI = async () => {
        service.getSDI().then((res) => {
          sdi.value = res.items
        })
      }
      const getHeadings = () => {
        service.getHeadings().then((res) => {
          fields.value = res.items
        })
      }
      const setSDI = async () => {
        switch (typeClient.value) {
          case 1:
          case 3:
          case 4:
            await getSDI()
            break;
          default:
            sdi.value = [{sdi:'0000000'}]
            break;
        }
      }
      const importRowsFileToTable = async ()  => {
        if (fileToUpload.value.length > 0) {
          const data = await fileToUpload.value[0].arrayBuffer();
          const workbook = XLSX.read(data);
          let first_sheet_name = workbook.SheetNames[0];
          let ws = workbook.Sheets[first_sheet_name];
          const headers = (XLSX.utils.sheet_to_json(ws, { header: 1 }))[0];
          const sheet = XLSX.utils.sheet_to_json(ws, {skipHeader:true, raw:false});
          for (let index = 0; index < 8; index++) {
            headers.pop();
          }
          const isSameHeaders = JSON.stringify(headers) === JSON.stringify(headings);
          if (!isSameHeaders) {
            toast.add({severity:'warn', summary:'Importazione fallita', detail: `Sembra che i nomi delle colonne del file sono diversi dal template richiesto. Puoi scaricare il template da questa pagina`});
            return;
          }
          const filteredRows = sheet
            .filter(row => Object.prototype.hasOwnProperty.call(row, 'RAGIONE_SOCIALE'))
            .map(row => {
              const newRow = { ...row };

              Object.keys(newRow).forEach(key => {
                if (key.startsWith('__EMPTY')) {
                  delete newRow[key];
                } 
                else if (key === 'CONSUMO_ANNUO') {
                  const value = String(newRow[key]).replace(/\s/g, '').replace(',', '.');
                  newRow[key] = Number(value);
                }
              });

              return newRow;
            });

          if (filteredRows.length > 0) {
            if (filteredRows.length < 201) {
              try {
                manualRows.value = filteredRows

                let i = 2
                let possibleDistricts = []
                districts.forEach(element => {
                  possibleDistricts.push(element.code)
                });

                let array_no_indirizzo = [
                    'TOPONIMO_FORNITURA',
                    'INDIRIZZO_FORNITURA',
                    'CIVICO_FORNITURA',
                    'SIGLA_PROVINCIA_FORNITURA',
                    'CITTA_FORNITURA',
                    'CAP_FORNITURA',
                  ]

                manualRows.value.forEach((row, index) => {
                  row['COD_ESITO'] = null
                  let possibleCities = []
                  let evt = {}
                  evt.value = null
                  let uso = ''
                  let nomeUso = '';
                  let nomeOfferta = '';
                  let nomeClasse = '';
                  let nomeDestinazione = '';
                  let code_sdi = '';
                  let validation = []

                  if ('RAGIONE_SOCIALE' in row) {
                    row['RAGIONE_SOCIALE'] = row['RAGIONE_SOCIALE'].trim();
                  }
                  if ('CODICE_FISCALE_PIVA' in row) {
                    row['CODICE_FISCALE_PIVA'] = row['CODICE_FISCALE_PIVA'].trim();
                  }
                  if ('IBAN' in row) {
                    row['IBAN'] = row['IBAN'].replace(/\s/g, "");
                    manualRows.value[index].checked_data_iban_equal_to_client = true
                    setDatiIbanRow(manualRows.value[index])
                  }
                  if ('POD_PDR' in row) {
                    row['POD_PDR'] = row['POD_PDR'].trim();
                  }
                  if ('TOPONIMO_FORNITURA' in row) {
                    row['TOPONIMO_FORNITURA'] = row['TOPONIMO_FORNITURA'].trim();
                  }
                  if ('INDIRIZZO_FORNITURA' in row) {
                    row['INDIRIZZO_FORNITURA'] = row['INDIRIZZO_FORNITURA'].trim();
                  }
                  if ('CIVICO_FORNITURA' in row) {
                    row['CIVICO_FORNITURA'] = row['CIVICO_FORNITURA'].toString().trim();
                  }
                  if ('CAP_FORNITURA' in row) {
                    row['CAP_FORNITURA'] = row['CAP_FORNITURA'].toString().trim();
                  }
                  if ('SIGLA_PROVINCIA_FORNITURA' in row) {
                    row['SIGLA_PROVINCIA_FORNITURA'] = row['SIGLA_PROVINCIA_FORNITURA'].trim().toUpperCase();
                  }
                  if ('CITTA_FORNITURA' in row) {
                    row['CITTA_FORNITURA'] = row['CITTA_FORNITURA'].trim().toUpperCase()
                  }
                  if ('USO' in row) {
                    row['USO'] = row['USO'].trim();
                  }
                  if ('OFFERTA' in row) {
                    row['OFFERTA'] = row['OFFERTA'].trim();
                  }
                  if ('CODICE_SDI' in row) {
                    row['CODICE_SDI'] = row['CODICE_SDI'].toString().trim();
                  }
                  
                  if (getSupplyTypeFromCode(row['POD_PDR'], { allowIncompletePod: true }) === 'pod') {
                    validation = [...validation_pod.value]
                  }else{
                    validation = [...validation_pdr.value]
                  }
                  
                  validation.forEach((element)=>{
                    let campo = null
                    let existProperty = element in row
                    if (!existProperty) {
                      validationErrors.value[`${element}_${index}`] = true
                    }else{
                      campo = sheet[index][element]
                      if (campo) {
                        switch (element) {
                          case 'CODICE_SDI':
                                code_sdi = ws['C'+i].w
                                row.CODICE_SDI = sdi.value ? sdi.value.find(el => el.sdi === code_sdi.trim()) : '';     
                                if (!row.CODICE_SDI) {
                                  validationErrors.value[`${element}_${index}`] = true
                                }
                              break;
                          case 'POD_PDR':
                            {
                              const rowType = getSupplyTypeFromCode(row['POD_PDR'], { allowIncompletePod: true })

                              usiOption.value[index] = rowType === 'pod'
                              ? usiEnergia.value.filter(uso => getUsiForTypeClient('Energia').includes(uso.id))
                              : rowType === 'pdr'
                                ? usiGas.value.filter(uso => getUsiForTypeClient('Gas').includes(uso.id))
                                : []

                              offerteOption.value[index] = rowType === 'pod'
                                ? offerteEnergia.value
                                : rowType === 'pdr'
                                  ? offerteGas.value
                                  : []
                              manualRows.value[index].TIPO = getSupplyTypeFromCode(row['POD_PDR'])
                            }
                            break;
                          case 'SIGLA_PROVINCIA_FORNITURA':
                              if (!possibleDistricts.includes(campo)) {
                                validationErrors.value[`${element}_IN_${index}`] = true
                                row.SIGLA_PROVINCIA_FORNITURA = ''
                              }else{
                                evt.value = campo
                                onSelectedDistrict(index, evt)
                                citiesGrouped.value[index].forEach(citta => {
                                  if (citta.provincia == campo) {
                                    possibleCities.push(citta.name.toUpperCase())
                                  }
                                });
                              }
                            break;
                          case 'CITTA_FORNITURA':
                              if (validationErrors.value[`SIGLA_PROVINCIA_FORNITURA_${index}`]) {
                                validationErrors.value[`${element}_NO_${index}`] = true
                                row.CITTA_FORNITURA = ''
                              }else if (!possibleCities.includes(campo.toUpperCase())) {
                                validationErrors.value[`${element}_IN_${index}`] = true
                                row.CITTA_FORNITURA = ''
                              }else{
                                row.CITTA_FORNITURA = campo.toUpperCase()
                              }
                            break;
                          case 'USO':
                              uso = ws['L'+i].v.split(' - ');
                              nomeUso = uso[1];
                              row.USO = usiOption.value[index] ? usiOption.value[index].find(uso => uso.name === nomeUso.trim()) : '';     
                              if (!row.USO) {
                                validationErrors.value[`${element}_NO_${index}`] = true
                              }else{
                                row.USO = row.USO.name
                              }
                            break;
                          case 'OFFERTA':
                              nomeOfferta = ws['M'+i].v;
                              row.OFFERTA = offerteOption.value[index] ? offerteOption.value[index].find(offerta => offerta.name.trim() === nomeOfferta.trim()) : '';     
                              if (!row.OFFERTA) {
                                validationErrors.value[`${element}_NO_${index}`] = true
                              }else{
                                row.OFFERTA = row.OFFERTA.id
                              }
                            break;
                          case 'CLASSE_MISURATORE':
                            nomeClasse = ws['O'+i].v;
                            row.CLASSE_MISURATORE = classeOption.find(classeOp => classeOp.classe.trim() === nomeClasse.trim())   
                            if (!row.CLASSE_MISURATORE) {
                              validationErrors.value[`${element}_NO_${index}`] = true
                            }
                          break;
                          case 'DESTINAZIONE_USO':
                            nomeDestinazione = ws['P'+i].v;
                            row.DESTINAZIONE_USO = destinazioneOption.find(destinazione => destinazione.name.trim() === nomeDestinazione.trim())     
                            if (!row.DESTINAZIONE_USO) {
                              validationErrors.value[`${element}_NO_${index}`] = true
                            }
                          break;
                        }                  
                      }else{
                        validationErrors.value[`${element}_${index}`] = true
                      }
                    }
                  })
                  if (typeClient.value == 2) {
                    if ('CODICE_SDI' in row) {
                      delete manualRows.value[index].CODICE_SDI
                    }
                  }
                  if (typeClient.value != 3) {
                    manualRows.value[index].RAGIONE_SOCIALE = typeClient.value == 2 ? `${props.formData.cliente.nome} ${props.formData.cliente.cognome}` : props.formData.cliente.ragsoc
                    manualRows.value[index].CODICE_FISCALE_PIVA = props.formData.cliente.codfis ?? props.formData.cliente.piva
                    manualRows.value[index].CODICE_SDI = props.formData.cliente.codiceDestinatario 
                    delete validationErrors.value[`RAGIONE_SOCIALE_${index}`]
                    delete validationErrors.value[`CODICE_FISCALE_PIVA_${index}`]
                    delete validationErrors.value[`CODICE_SDI_${index}`]
                  }
                  if (['s'].includes(pratica.value)) {
                    manualRows.value[index].STAGIONALITA = 'No'
                  }
                  if (['ap'].includes(pratica.value)) {
                    manualRows.value[index].STAGIONALITA_RICORRENTE = 'No'
                    manualRows.value[index].DISALIMENTABILE = 'Si'
                    manualRows.value[index].CONNESSIONE = 'Permanente'
                    manualRows.value[index].USO_ENERGIA = 'Ordinaria'
                    manualRows.value[index].DICHIARAZIONE = 'Condotta in locazione in uso per:'
                    manualRows.value[index].POTENZA_SELEZIONATA = null

                    if ([2].includes(typeClient.value)) {
                      manualRows.value[index].TENSIONE = tensioneOption.value[0].value
                    }else{
                      manualRows.value[index].TENSIONE = tensioneOption.value[1].value
                    }
                  }
                  if (['v'].includes(pratica.value)) {
                    manualRows.value[index].TIPO_VOLTURA = 'Ordinaria'
                  }
                  i++
                });
                activeTabIndex.value = 0
              } catch (error) {
                toast.add({severity:'warn', summary:'Importazione fallita', detail: error, life:5000});
              }
            }else{
              toast.add({severity:'warn', summary:'Importazione fallita', detail: 'Non è possibile inserire più di 200 punti di fornitura', life:5000});
            }
          } else {
            toast.add({severity:'warn', summary:'Importazione fallita', detail: 'Il primo foglio di lavoro è vuoto', life:5000});
          }
        }
      }
      const set_rowsType_to_manualRows = (device,type_supply) => {
        let newRow = headings.reduce((obj, key) => ({...obj, [key]: ''}), {});

        newRow.TIPO = device
        newRow.RAGIONE_SOCIALE = `${cliente.value.nome} ${cliente.value.cognome}`
        newRow.CODICE_FISCALE_PIVA = cliente.value.codfis
        newRow.CODICE_SDI = cliente.value.sdi
        newRow.TOPONIMO_FORNITURA = eval(`row_${type_supply}`).value.addressEqual ? cliente.value.toponimo : eval(`row_${type_supply}`).value.toponimo
        newRow.INDIRIZZO_FORNITURA = eval(`row_${type_supply}`).value.addressEqual ? cliente.value.indirizzo : eval(`row_${type_supply}`).value.indirizzo
        newRow.CIVICO_FORNITURA = eval(`row_${type_supply}`).value.addressEqual ? cliente.value.civico : eval(`row_${type_supply}`).value.civico
        newRow.CAP_FORNITURA = eval(`row_${type_supply}`).value.addressEqual ? cliente.value.cap : eval(`row_${type_supply}`).value.cap
        newRow.CITTA_FORNITURA = eval(`row_${type_supply}`).value.addressEqual ? cliente.value.nome_comune : eval(`row_${type_supply}`).value.nome_comune
        newRow.SIGLA_PROVINCIA_FORNITURA = eval(`row_${type_supply}`).value.addressEqual ? cliente.value.provincia : eval(`row_${type_supply}`).value.provincia

        newRow.IBAN = eval(`row_${type_supply}`).value.iban.toUpperCase()
        if (eval(`row_${type_supply}`).value.iban) {
          newRow.checked_data_iban_equal_to_client = eval(`row_${type_supply}`).value.checked_data_iban_equal_to_client
          newRow.INTESTAZIONE_IBAN = eval(`row_${type_supply}`).value.intestazione_iban.toUpperCase()
          newRow.CODICE_FISCALE_PIVA_IBAN = eval(`row_${type_supply}`).value.codice_fiscale_piva_iban.toUpperCase()
        }
        newRow.POD_PDR = eval(`row_${type_supply}`).value.code
        newRow.USO = eval(`row_${type_supply}`).value.uso ?? null
        newRow.OFFERTA = eval(`row_${type_supply}`).value.offerta ?? null
        if (device == 'pdr') {
          newRow.MATRICOLA = eval(`row_${type_supply}`).value.matricola
          newRow.checked_matricola_not_found = eval(`row_${type_supply}`).value.checked_matricola_not_found
          newRow.CLASSE_MISURATORE = eval(`row_${type_supply}`).value.classe
          newRow.DESTINAZIONE_USO = eval(`row_${type_supply}`).value.destinazione
          newRow.CONSUMO_ANNUO = eval(`row_${type_supply}`).value.consumo
        }
        newRow.POD_PDR_INVALID = false
        manualRows.value.push(newRow)          
      }
      const nextPage = async () => {
        emit("activeLoader", true)
        toast.removeGroup('failPrecheck')
        toast.removeGroup('PrecheckKO')
        submitted.value = true;
        prechecked.value = false

        if (views.value == 'basic') {
          initManualRows()
          if (row_ee.value.exist) {
            set_rowsType_to_manualRows('pod','ee')
          }
          if (row_gas.value.exist) {
            set_rowsType_to_manualRows('pdr','gas')
          }
        }
        
        await validateForm()
        .then((res) => {
          if (res) {
            loading.value = true
            manualRows.value.forEach((row, i)=>{
              manualRows.value[i].PRECHECKOK = true
              if (is_pratica.value) {
                manualRows.value[i].DATA_DECORRENZA_FORMATTED = setData(manualRows.value[i].DATA_DECORRENZA)
                if ('DATA_CONNESSIONE' in manualRows.value[i]) {
                  manualRows.value[i].DATA_CONNESSIONE_FORMATTED = setData(manualRows.value[i].DATA_CONNESSIONE)
                }
              }
            })

            toast.removeGroup('inactivePrecheck')
            emit('next-page', {
              formData: 
              {
                "view": views.value,
                "manualRows": manualRows.value,
                "type_matrice": type_matrice.value,
              }
              ,pageIndex: stepIndex
            });            
          }else{
            emit("activeLoader", false)
          }
        })
      }
      const setData = (el) => {
        let giorno = el.getDate() 
        let mese = el.getMonth()+1
        mese = mese.toString().padStart(2,'0')
        let anno = el.getFullYear() 
        return `${anno}-${mese}-${giorno}`
      } 

      const getPrecheckIsValid = async (data) => {
        toast.add({severity:'info', summary: `Precheck in corso...`, detail: `Tempo di attesa stimato di 2 minuti`, group: 'tc'});
        emit("activeLoader", true)
        return service.getPrecheck(data)
        .then((res)=>{
          toast.removeGroup('tc')
          emit("activeLoader", false)
          return res.item
        })
      }

      const getRemi = (city = null, id = null) => {
        service.getRemi(city).then((res) => {
          if (!city) {
            totalRemi.value = res.items
          }else{
            remiOption.value[id] = res.items
          }
        })
      }

      // const getClassiGas = () => {
      //   service.getClassiGas().then((res) => {
      //     res.items.forEach((item)=>{
      //       item.classe = item.classe.replace(',','.')
      //     })
      //     classeOption.value = res.items
      //   })
      // }

      // const getCategorieGas = () => {
      //   service.getCategorieGas().then((res) => {
      //     destinazioneOption.value = res.items
      //   })
      // }

      const prevPage = () => {
        if (typeClient.value == 2) {
          stepIndex = 1
        }
        emit('prev-page', {
          formData: {
            view: views.value,
            manualRows: manualRows.value,
            type_matrice: type_matrice.value,
          },
          pageIndex: stepIndex
        });
      }

      const onCellEditComplete = (event) => {
        let {field, index, restoringRow = false} = event
        delete validationErrors.value[`${field}_${index}`];
        if (field === 'POD_PDR') {
          const previousType = manualRows.value[index].TIPO
          manualRows.value[index]['POD_PDR'] = manualRows.value[index]['POD_PDR'].toUpperCase()
          // Keep copied values while a condominium supply is waiting for its new code.
          if (typeClient.value === 3 && manualRows.value[index].POD_PDR === '' && ['pod', 'pdr'].includes(previousType)) return
          const rowType = getSupplyTypeFromCode(manualRows.value[index]['POD_PDR'], { allowIncompletePod: true })
          delete validationErrors.value[`USO_NO_${index}`];
          delete validationErrors.value[`OFFERTA_NO_${index}`];
          delete validationErrors.value[`${field}_duplicate_${index}`];
          delete validationErrors.value[`${field}_contractualized_${index}`];
          delete validationErrors.value[`${field}_precheck_${index}`];
          delete validationErrors.value[`${field}_INVALID_${index}`];

          if (!manualRows.value[index].PRECHECKOK) { 
            usiOption.value[index] = []
            offerteOption.value[index] = []
            if (manualRows.value[index][field] != '') {
              usiOption.value[index] = rowType === 'pod'
              ? usiEnergia.value.filter(uso => getUsiForTypeClient('Energia').includes(uso.id))
              : rowType === 'pdr'
                ? usiGas.value.filter(uso => getUsiForTypeClient('Gas').includes(uso.id))
                : []

              offerteOption.value[index] = rowType === 'pod'
                ? offerteEnergia.value
                : rowType === 'pdr'
                  ? offerteGas.value
                  : []
            }
            if (manualRows.value[index]['USO'] != '' && manualRows.value[index]['USO'] != null) {
              manualRows.value[index]['USO'] = usiOption.value[index].find(option => option.name ==  manualRows.value[index]['USO']) ? manualRows.value[index]['USO'] : ''
            }
            
            if (usiOption.value[index].length == 1) {
              manualRows.value[index]['USO'] = usiOption.value[index][0].name
            }
            
            if (manualRows.value[index]['OFFERTA'] != '' && manualRows.value[index]['OFFERTA'] != null) {
              manualRows.value[index]['OFFERTA'] = offerteOption.value[index].find(option => option.id ==  manualRows.value[index]['OFFERTA']) ? manualRows.value[index]['OFFERTA'] : ''
            }
            
            if (offerteOption.value[index].length == 1) {
              manualRows.value[index]['OFFERTA'] = offerteOption.value[index][0].id
            }
          }
          manualRows.value[index].TIPO = getSupplyTypeFromCode(manualRows.value[index]['POD_PDR'])
          if (manualRows.value[index].POD_PDR != '') {
            let is_visible = isVisibleAddress(index)
            if (is_visible) {
              if (typeClient.value != 3 && !restoringRow) {
                manualRows.value[index].TOPONIMO_FORNITURA = props.formData.cliente.toponimo
                manualRows.value[index].INDIRIZZO_FORNITURA = props.formData.cliente.indirizzo
                manualRows.value[index].CIVICO_FORNITURA = props.formData.cliente.civico
                manualRows.value[index].CAP_FORNITURA = props.formData.cliente.cap

                manualRows.value[index].SIGLA_PROVINCIA_FORNITURA = props.formData.cliente.provincia

                citiesGrouped.value[index] = opzioni.getCities(props.formData.cliente.provincia)
                manualRows.value[index].CITTA_FORNITURA = opzioni.getNameCityById(props.formData.cliente.cod_comune)
                
                if(manualRows.value[index].TIPO == 'pdr' && ['s', 'ap'].includes(pratica.value)){
                  delete remiOption.value[index]
                  getRemi(manualRows.value[index].CITTA_FORNITURA, index)
                }
              }
            }
            if (manualRows.value[index].TIPO == 'pdr' && previousType !== 'pdr') {
              manualRows.value[index].checked_matricola_not_found = false
            }
            delete validationErrors.value[`TOPONIMO_FORNITURA_${index}`];
            delete validationErrors.value[`INDIRIZZO_FORNITURA_${index}`];
            delete validationErrors.value[`CIVICO_FORNITURA_${index}`];
            delete validationErrors.value[`CAP_FORNITURA_${index}`];
            delete validationErrors.value[`SIGLA_PROVINCIA_FORNITURA_${index}`];
            delete validationErrors.value[`CITTA_FORNITURA_${index}`];
          }

        }else if(field == 'CODICE_FISCALE_PIVA'){
          delete validationErrors.value[`${field}_precheck_${index}`];
        }else if(field == 'CODICE_FISCALE_PIVA_PRECEDENTE'){
          delete validationErrors.value[`${field}_INVALID_${index}`];
          delete validationErrors.value[`${field}_${index}`];
        }
      }
      const getUsiForTypeClient = (type) => {
        return eval(`possible_usi${type}_for_typeClient`).value.find(poss_uso => poss_uso.typeClient == typeClient.value).id_usi
      }

      const removeFile = () => {
        keyInputReset.value = new Date()
        fileToUpload.value = []
      }

      const validateForm = async () => {
        initValidationRowErrors() 
        let regexIban = /^(IT\d{2}[A-Z]\d{10}[0-9A-Z]{12})$/;
        let regexCf = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
        let regexPiva = /^[0-9]{11}$/
        validationErrors.value = []
        type_matrice.value = ''
        
        // let validOfferta = null
        let type_device = [];
        let supply = {
          pod:[],
          pdr:[]
        }
        manualRows.value.forEach((el, i) => {          
          el.FREQUENZA = props.formData.frequenza
          let validation = el.TIPO == 'pod' ? Array.from(new Set(validation_pod.value)) : Array.from(new Set(validation_pdr.value))
          if(pratica.value != null){
            validation.push('DATA_DECORRENZA')  
            if (pratica.value == 'v') {
              validation.push('CF_ATTIVAZIONE')
            }
            if(el.TIPO == 'pdr'){
              if (pratica.value == 's') {
                validation.push('REMI')
              }
              if (pratica.value == 'ap') {
                validation.push('POTENZA_TERMICA')
                validation.push('REMI')
              }
            }
            if(el.TIPO == 'pod'){
              if (pratica.value == 'ap') {
                validation.push('DICHIARAZIONE_TEXT')
                validation.push('POTENZA_IMPEGNATA')
              }
            }
          }

          if (el.TIPO == 'pod' && !isVisibleAddress(i)) {
            let array_validation_pod = [
            'TOPONIMO_FORNITURA',
            'INDIRIZZO_FORNITURA',
            'CIVICO_FORNITURA',
            'CAP_FORNITURA',
            'SIGLA_PROVINCIA_FORNITURA',
            'CITTA_FORNITURA'
            ]
            array_validation_pod.forEach(el => {
              let index = validation.findIndex(field => field == el)
              if (index) {
                validation.splice(index,1)
              }
            });
          }

          if('IBAN' in el && el.IBAN){
            validation.push('IBAN')
            validation.push('INTESTAZIONE_IBAN')
            validation.push('CODICE_FISCALE_PIVA_IBAN')
          }

          switch (typeClient.value) {
            case 1:
            case 3:
            case 4:
              validation.push('CODICE_SDI');
              break;
            default:
              manualRows.value[i].CODICE_SDI = '0000000'
              break;
          }
          type_device[i] = el.TIPO;
          
          validation.forEach((element)=>{
            let existProperty = element in el
            if (!existProperty) {
              validationErrors.value[`${element}_${i}`] = true
            }else{
              switch (element) {
                case 'RAGIONE_SOCIALE':
                  if (el[element].trim() == '') {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                  }
                  break;
                case 'CODICE_FISCALE_PIVA':
                  if (el[element].toString().length == 11) {
                    if (!regexPiva.test(el[element])) {
                      validationErrors.value[`${element}_${i}`] = true
                    } else {
                      delete validationErrors.value[`${element}_${i}`];
                    }
                  } else if (el[element].toString().length == 16) {
                    if (!regexCf.test(el[element])) {
                      validationErrors.value[`${element}_${i}`] = true
                    } else {
                      delete validationErrors.value[`${element}_${i}`];
                    }
                  } else {
                    validationErrors.value[`${element}_${i}`] = true
                  }
                  break;
                case 'POD_PDR':
                  if (el[element] != '') {
                    if (regexPod.test(el[element]) || regexPdr.test(el[element])) {
                      if (regexPod.test(el[element]) && !verificaCodiceDistributore(el[element])) {
                        validationErrors.value[`${element}_INVALID_${i}`] = true
                      }
                      if (supply[el.TIPO].includes(el[element])) {
                        validationErrors.value[`${element}_duplicate_${i}`] = true;
                      }
                      supply[el.TIPO].push(el[element])
                      delete validationErrors.value[`${element}_${i}`];
                    } else {
                      validationErrors.value[`${element}_INVALID_${i}`] = true
                    }                  
                  }else{
                    validationErrors.value[`${element}_${i}`] = true
                  }
                  break;
                case 'USO':
                  if (el[element].length == 0) {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                  }
                  break;
                case 'OFFERTA':
                  delete validationErrors.value[`OFFERTA_NO_${i}`]
                  if (!el.OFFERTA) {
                    validationErrors.value[`OFFERTA_${i}`] = true
                  } else {
                    delete validationErrors.value[`OFFERTA_${i}`]
                    const supplyType = getSupplyTypeFromCode(el.POD_PDR)
                    const supplyOffers = supplyType === 'pod' ? offerteEnergia.value : supplyType === 'pdr' ? offerteGas.value : []
                    if (!supplyOffers.some(offerta => String(offerta.id) === String(el.OFFERTA))) {
                      validationErrors.value[`OFFERTA_NO_${i}`] = true
                    }
                  }
                  break;
                case 'CLASSE_MISURATORE':
                case 'MATRICOLA':
                case 'DESTINAZIONE_USO':
                  if (!el[element] || el[element].length == 0 || el[element] == '' || el[element] == null) {
                    validationErrors.value[`${element}_${i}`] = true
                    if (element == 'MATRICOLA') delete validationErrors.value[`${element}_INVALID_${i}`]
                  } else if (element == 'MATRICOLA' && isStrictGasMatricola.value && isInvalidGasMatricola(el[element])) {
                    validationErrors.value[`${element}_INVALID_${i}`] = true
                    delete validationErrors.value[`${element}_${i}`]
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                    if (element == 'MATRICOLA') delete validationErrors.value[`${element}_INVALID_${i}`]
                  }
                break;
                case 'CODICE_SDI':
                  if (el[element].trim().length == 7) {
                    delete validationErrors.value[`${element}_${i}`];
                    delete validationErrors.value[`${element}_NO_${i}`];
                  } else {
                    if (el[element].trim() != '') {
                      validationErrors.value[`${element}_NO_${i}`] = true
                    } else {
                      validationErrors.value[`${element}_${i}`] = true
                    }
                  }
                  break;
                case 'CF_ATTIVAZIONE':
                  if (el[element] != '' && el[element] != null) {
                    delete validationErrors.value[`${element}_${i}`];

                    let regex 
                    if (el[element].length < 11 || el[element].length > 16) {
                      validationErrors.value[`${element}_INVALID_${i}`] = true
                    }else{
                      if (el[element].length == 16) {
                        regex = regexCf
                      }else if(el[element].length == 11){
                        regex = regexPiva
                      }
                      
                      if (!regex.test(el[element])) {
                        validationErrors.value[`${element}_INVALID_${i}`] = true
                      } else {
                        delete validationErrors.value[`${element}_INVALID_${i}`];
                      }      
                      
                      // if (el[element] == el.CODICE_FISCALE_PIVA) {
                      //   validationErrors.value[`${element}_equal_${i}`] = true
                      // } else {
                      //   delete validationErrors.value[`${element}_equal_${i}`];
                      // }      
                    }
                  } else {
                    validationErrors.value[`${element}_${i}`] = true
                  }
                  break;
                case 'PIVA_ATTIVAZIONE':
                  if (el[element] != '' && el[element] != null) {
                    delete validationErrors.value[`${element}_${i}`];

                    if (!regexPiva.test(el[element])) {
                      validationErrors.value[`${element}_INVALID_${i}`] = true
                    } else {
                      delete validationErrors.value[`${element}_INVALID_${i}`];

                      // if (el[element] == el.CODICE_FISCALE_PIVA) {
                      //   validationErrors.value[`${element}_equal_${i}`] = true
                      // } else {
                      //   delete validationErrors.value[`${element}_equal_${i}`];
                      // }
                    }              
                  } else {
                    validationErrors.value[`${element}_${i}`] = true
                  }
                  break;
                case 'CITTA_FORNITURA':
                case 'SIGLA_PROVINCIA_FORNITURA':
                case 'DICHIARAZIONE_TEXT':
                  if (el[element] != '' && el[element] != null) {
                    delete validationErrors.value[`${element}_${i}`];
                    let string = el[element]
                    if (element == 'DICHIARAZIONE_TEXT') {
                      string = string.replace(`${el.DICHIARAZIONE} `,'')
                    }
                    
                    if (string.length <= 81) {
                      delete validationErrors.value[`${element}_LENGTH_${i}`];
                    } else {
                      validationErrors.value[`${element}_LENGTH_${i}`] = true
                    }
                  } else {
                    validationErrors.value[`${element}_${i}`] = true
                  }
                  break;  
                case 'TOPONIMO_FORNITURA':
                case 'INDIRIZZO_FORNITURA':
                case 'CIVICO_FORNITURA':
                  el[element] = el[element].toString()
                  if (el[element].trim() == '') {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                  }
                  break;
                case 'CAP_FORNITURA':
                  el[element] = el[element].toString()
                  if (el[element].trim() == '' || el[element].length != 5) {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                  } 
                  break;
                case 'REMI':
                  if (el[element].trim() == '' || el[element].trim() == null) {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                    if (el[element].toString().length >= 8) {
                      delete validationErrors.value[`${element}_ERROR_${i}`];
                    } else {
                      validationErrors.value[`${element}_ERROR_${i}`] = true
                    }
                  }
                  break;
                case 'CONSUMO_ANNUO':
                case 'POTENZA_TERMICA':
                case 'POTENZA_IMPEGNATA':
                  if (el[element] <= 0 || el[element] == '') {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                  }
                  break;
                case 'IBAN':
                  if (el[element] != '') {
                    if (regexIban.test(el[element])) {
                      delete validationErrors.value[`${element}_${i}`];
                    } else {
                      validationErrors.value[`${element}_INVALID_${i}`] = true
                    }                  
                  }else{
                    validationErrors.value[`${element}_${i}`] = true
                  }
                  break;
                case 'INTESTAZIONE_IBAN':
                  if (el[element] == '') {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                    if(!el.checked_data_iban_equal_to_client && el[element] == el.RAGIONE_SOCIALE){
                      validationErrors.value[`${element}_INVALID_${i}`] = true
                    }else{
                      delete validationErrors.value[`${element}_INVALID_${i}`];
                    }
                  }
                  break;
                case 'CODICE_FISCALE_PIVA_IBAN':
                  if (el[element] == '') {
                    validationErrors.value[`${element}_${i}`] = true
                  } else {
                    delete validationErrors.value[`${element}_${i}`];
                    if(!el.checked_data_iban_equal_to_client && el[element] == el.CODICE_FISCALE_PIVA){
                      validationErrors.value[`${element}_INVALID_${i}`] = true
                    }else{
                      delete validationErrors.value[`${element}_INVALID_${i}`];
                    }
                  }
                  break;
              }
            }
          })
        });
        type_device = Array.from(new Set(type_device));
        if (type_device.length > 1) {
          type_matrice.value = 'ee/gas'
        }else{
          type_matrice.value = type_device[0] == 'pod' ? 'ee' : 'gas'
        }
        if (!isAdmin.value) {
          let existentSupply = await checkSupply(supply)
          Object.keys(existentSupply.items).forEach((supply) => {
            Object.keys(existentSupply.items[supply]).forEach((pp) => {
              let exist = existentSupply.items[supply][pp]
              
              manualRows.value.forEach((el, i) => {
                if (el['POD_PDR'] == pp) {
                  if (exist) {
                    validationErrors.value[`POD_PDR_contractualized_${i}`] = true
                    if (views.value == 'basic') {
                      let type_supply = type_device_supply[el.TIPO]
                      validationRowErrors.value[type_supply][`POD_PDR_EXISTENT`] = true
                    }
                  }
                }
              })
            })
          })
        }

        let activeSupply = await checkSupplyActive(supply)
        Object.keys(activeSupply.items).forEach((supply) => {
          Object.keys(activeSupply.items[supply]).forEach((pp) => {
            let exist = activeSupply.items[supply][pp]
            manualRows.value.forEach((el, i) => {
              if (el['POD_PDR'] == pp) {
                if (exist) {
                  toast.add({severity:'info', summary:'Fornitura già attiva', detail: "La fornitura "+el['POD_PDR']+" risulta già attiva.", life:3000});
                }
              }
            })
          })
        })
        console.log(validationErrors.value)
        if (Object.keys(validationErrors.value).length > 0) {
          toast.add({severity:'warn', summary:'Campi Errati', detail: 'Alcuni campi sembrano vuoti o errati', life:3000});
          if (views.value == 'basic') {
            setErrorsLiteRows()
          }
          return false
        }
        return true
      }
      const setErrorsLiteRows = () => {
        manualRows.value.forEach((row, i)=>{
          let type_supply = type_device_supply[row.TIPO]
          
          Object.keys(row).forEach(prop=>{
            if (`${prop}_${i}` in validationErrors.value) {
              validationRowErrors.value[type_supply][prop] = true
            }
            if (`${prop}_INVALID_${i}` in validationErrors.value) {
              validationRowErrors.value[type_supply][`${prop}_INVALID`] = true
            }
          })
        })
        initManualRows()
        validationErrors.value = []
      }

      const verificaCodiceDistributore = (stringa) => {
        const indiceInizio = stringa.indexOf("IT") + 2; // Indice del primo numero
        const indiceFine = stringa.indexOf("E", indiceInizio);
        const treCifre = stringa.substring(indiceInizio, indiceFine);
        return cod_distributori.value.includes(treCifre);
      }

      const initValidationRowErrors = () => {
        validationRowErrors.value = {
          ee:{
            RAGIONE_SOCIALE: false,
            CODICE_FISCALE_PIVA: false,
            POD_PDR: false,
            POD_PDR_EXISTENT: false,
            POD_PDR_INVALID: false,
            TOPONIMO_FORNITURA: false,
            INDIRIZZO_FORNITURA: false,
            CIVICO_FORNITURA: false,
            CAP_FORNITURA: false,       
            SIGLA_PROVINCIA_FORNITURA: false,
            CITTA_FORNITURA: false,
            USO: false,
            OFFERTA: false,
            INTESTAZIONE_IBAN: false,
            CODICE_FISCALE_PIVA_IBAN: false,
            INTESTAZIONE_IBAN_INVALID: false,
            CODICE_FISCALE_PIVA_IBAN_INVALID: false
          },
          gas:{
            RAGIONE_SOCIALE: false,
            CODICE_FISCALE_PIVA: false,
            POD_PDR: false,
            POD_PDR_INVALID: false,
            POD_PDR_EXISTENT: false,
            TOPONIMO_FORNITURA: false,
            INDIRIZZO_FORNITURA: false,
            CIVICO_FORNITURA: false,
            CAP_FORNITURA: false,       
            SIGLA_PROVINCIA_FORNITURA: false,
            CITTA_FORNITURA: false,
          USO: false,
          OFFERTA: false,
          MATRICOLA: false,
          MATRICOLA_INVALID: false,
          CLASSE_MISURATORE: false,
            DESTINAZIONE_USO: false,
            CONSUMO_ANNUO:false,
            INTESTAZIONE_IBAN: false,
            CODICE_FISCALE_PIVA_IBAN: false,
            INTESTAZIONE_IBAN_INVALID: false,
            CODICE_FISCALE_PIVA_IBAN_INVALID: false
          }
        }
      } 

      const onChangeDate = (evt, i) => {
        delete validationErrors.value[`DATA_DECORRENZA_${i}`]
      }

      const checkSupply = async (obj) => {
        // emit("activeLoader", true)
        return service.checkSupply(obj)
        // .finally(() => {
        //   emit("activeLoader", false)
        // })   
      }

      const checkSupplyActive = async (obj) => {
        // emit("activeLoader", true)
        return service.checkSupplyActive(obj)
        // .finally(() => {
        //   emit("activeLoader", false)
        // })   
      }
      const isResidential = computed (()=>{
        return row_ee.value.uso && row_ee.value.uso == 'Domestico residente'
      })

      const openCodDistributori = () => {
        visibleCodDistributori.value = !visibleCodDistributori.value;
      }
      const onChangeLimitatore = (evt, i) => {
        if (evt) {
          manualRows.value[i].POTENZA_DISPONIBILE = manualRows.value[i].POTENZA_SELEZIONATA.value
        }else{
          manualRows.value[i].POTENZA_DISPONIBILE = manualRows.value[i].POTENZA_SELEZIONATA.value+(manualRows.value[i].POTENZA_SELEZIONATA.value*0.1)
        }
      }

      const setDatiIbanLite = (row, type) => {
        row.intestazione_iban = row.checked_data_iban_equal_to_client 
        ? `${cliente.value.nome} ${cliente.value.cognome}` 
        : ''
        
        row.codice_fiscale_piva_iban = row.checked_data_iban_equal_to_client 
        ? cliente.value.codfis 
        : ''

        validationRowErrors.value[type][`INTESTAZIONE_IBAN`] = false
        validationRowErrors.value[type][`CODICE_FISCALE_PIVA_IBAN`] = false

        validationRowErrors.value[type][`INTESTAZIONE_IBAN_INVALID`] = false
        validationRowErrors.value[type][`CODICE_FISCALE_PIVA_IBAN_INVALID`] = false
      }

      const setDatiIbanRow = (data) => {      
        if (data.checked_data_iban_equal_to_client) {
          data.INTESTAZIONE_IBAN = data.RAGIONE_SOCIALE
          
          const cfPiva = data.CODICE_FISCALE_PIVA
          const rappCodFis = getRappresentanteCodfis()

          switch (typeClient.value) {
            case 2:
            case 3:
            case 5:

              data.CODICE_FISCALE_PIVA_IBAN = data.CODICE_FISCALE_PIVA
              break;

            case 6:
              data.CODICE_FISCALE_PIVA_IBAN = cfPiva.startsWith('0') 
              ? cfPiva 
              : rappCodFis;
              break;

            default:
              data.CODICE_FISCALE_PIVA_IBAN = rappCodFis;
              break;
          }
        }
      }
      const getRappresentanteCodfis = () => {
        return rappresentante.value?.codfis
          || rappresentante.value?.cod_fiscale
          || props.formData.rappresentante?.codfis
          || props.formData.rappresentante?.cod_fiscale
          || ''
      }
      const refreshIbanRowsFromCurrentData = () => {
        manualRows.value.forEach(row => {
          if (row.IBAN && row.checked_data_iban_equal_to_client) {
            setDatiIbanRow(row)
          }
        })
      }

      return {
        route,
        loading,
        moment,
        activeTabIndex,
        downloadTemplate,
        headings,
        manualRows,
        addRow,
        canCloneRow,
        cloneRow,
        deleteRow,
        editingRows,
        validationErrors,
        submitted, 
        prevPage, 
        validateForm, 
        handleFileUpload,
        fileToUpload,
        offerte,
        allowedType,
        keyInputReset,
        nextPage,
        importRowsFileToTable,
        initManualRows,
        onCellEditComplete,
        removeFile,
        showModal,
        matrice_id,
        cities,
        districts,
        toponimi,
        onSelectedDistrict,
        onSelectedSdi,
        onSelectedCity,
        onSelectedClasse,
        onSelectedStagionalita,
        onSelectedDestinazione,
        // getDistricts,
        citiesGrouped,
        onSelectedOfferta,
        onSelectedUso,
        onSelectedRemi,
        usiOption,
        usiEnergia,
        usiGas,
        offerteOption,
        offerteEnergia,
        offerteGas,
        esiti_voltura,
        esiti_subentro,
        prechecked,
        remiOption,
        destinazioneOption,
        classeOption,
        stagionalitaOption,
        volturaOption,
        sdi,
        toggle,
        op,
        dati_iban,
        hideOverlayDatiIban,
        fields,
        slides,
        typeClient,
        setOfferte,
        breakpoint,
        windowSize,
        responsiveLayout,
        // has_cf_attivazione,
        maskCF,
        maskCFiban,
        // has_piva_attivazione,
        minDate,
        is_pratica,
        canChangeUploadView,
        pratica,
        isStrictGasMatricola,
        onChangeDate,
        onInput,
        isVisibleAddress,
        views,
        cliente,
        contatto,
        rappresentante,
        getPecRappresentante,
        getContattoData,
        addRowForType,
        row_ee,
        row_gas,
        removeRowForType,
        onSelectedDistrictForType,
        checked_basic_view,
        changeViews,
        canGoToNextPage,
        validationRowErrors,
        removeError,
        usiEnergiaDomestico,
        usiGasDomestico,
        isResidential,
        cod_distributori,
        visibleCodDistributori,
        openCodDistributori,
        minDataStagionalita,
        motivazioniDisalimentabileOption,
        onSelectedDisalimentabile,
        onSelectedConnessione,
        connessioneOption,
        usoEnergiaApOption,
        tensioneOption,
        dichiarazioneOption,
        onChangeDichiarazione,
        onSelectedDichiarazione,
        onSelectedPotenza,
        potenzaOption,
        onChangeLimitatore,
        setMatricola,
        setDatiIbanRow,
        setDatiIbanLite,
        canChangeDatiIban,
        maskCFibanLite,
        selectedRow,
        selectedIndex,
      }
    },
  }
</script>
<style>
.text_toupper{
  text-transform: uppercase;
}
.stepUpload-multisito .p-hidden-accessible{
  display: none;
}

.p-success {
  color: rgb(4, 254, 0);
  font-weight:400;
}

.font-size{
  font-size: 1rem;
}

@media screen and (max-width: 400px){
  .font-size{
    font-size: x-small;
  }
}
.input-iban{
  width: 230px !important;
}
</style>

<style scoped>
  .manual-rows-table-sticky :deep(.row-actions-column) {
    position: sticky;
    left: 0;
    z-index: 1;
    background: var(--surface-a, #fff);
    box-shadow: 1px 0 0 var(--surface-border, #dee2e6);
  }
  .manual-rows-table-sticky :deep(.p-datatable-thead > tr > .row-actions-column) {
    z-index: 2;
    background: var(--surface-b, #f8f9fa);
  }
  .row-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: nowrap;
  }
  .row-actions .row-action {
    width: 2rem;
    height: 2rem;
    padding: 0;
    flex-shrink: 0;
    border-radius: 0.5rem;
    transition: background-color 0.15s, border-color 0.15s;
  }
  .row-action-clone {
    background: #eff6ff;
    border-color: #bfdbfe;
    color: #2563eb;
  }
  .row-action-delete {
    background: #fff1f2;
    border-color: #fecdd3;
    color: #e11d48;
  }
  .row-actions :deep(.p-button-icon) {
    font-size: 0.9rem;
  }
  .btn-offerte{
    border-radius: 50% !important;
    background-color: rgb(233, 233, 233);
    color: rgb(105, 105, 105);
    border: 1px solid rgba(255, 255, 255, 0);
  }
  .btn-offerte:hover {
    background-color: rgb(233, 233, 233);
    color: rgb(105, 105, 105);
    border-color: #2196F3;
  }

.p-card{
  min-width: 335px !important;
}

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 250px;
  border: 2px dashed rgba(156, 156, 156, 0.577);
  border-radius: 5px;
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 250px;
  background: #ffffff;
  /* border: 1px solid rgb(217, 217, 217) !important;  */
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  box-shadow: none;
}

.form-file  .remove-file {
    color: red;
    margin-top:15px;
    cursor: pointer;
    text-align: center;
    text-transform: uppercase;
    font-size: 12px;
}

.form-file .button-wrapper span.label.active {
  color: #2196F3;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100% !important;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

.p-button-luce{
  background: linear-gradient(180deg, rgba(249,255,0,.65) 0%, rgba(189,255,0,.65) 100%);
  border-color: rgba(249,255,0,1);
  color:rgb(33, 150, 243);
}
.p-button-gas{
  background: linear-gradient(180deg, rgba(0,112,255,.65) 0%, rgba(0,189,255,.65) 100%);
  border-color: rgba(0,112,255,1);
  color:rgb(255, 255, 255);
}
.p-button-luce:hover{
  background: linear-gradient(180deg, rgba(249,255,0,1) 0%, rgba(189,255,0,1) 100%);
  border-color: rgba(249,255,0,1);
  color:rgb(33, 150, 243);
}
.p-button-gas:hover{
  background: linear-gradient(180deg, rgba(0,112,255,1) 0%, rgba(0,189,255,1) 100%);
  border-color: rgba(0,112,255,1);
  color:rgb(255, 255, 255);
}

.p-button-custom:hover{
  opacity: 1;
}
.p-button-custom{
  width: 100% !important;
  height: 450px;
  border-radius: 20px;
  overflow-y: auto;
}
.text-yellow{
  color: rgba(249,255,0,1);
}
.icon-custom{
  width: 21px;
  aspect-ratio: 1;
}
.customer-summary {
  padding: 0.75rem;
}
.customer-summary-grid {
  gap: 0.75rem;
}
.customer-summary-card {
  flex: 1 1 22%;
  min-width: 150px;
  padding: 0.75rem;
  overflow-wrap: anywhere;
}
.customer-summary-card label {
  display: block;
  margin-top: 0.35rem;
  line-height: 1.2;
}
.customer-summary-card label:first-child {
  margin-top: 0;
}
.customer-summary-card p {
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: anywhere;
}
.btn-reset:hover {
  background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
  opacity: 1;
}
@media screen and (max-width: 1400px) {
  .p-button-custom{
    height: 200px;
  }
}
@media screen and (max-width: 767px) {
  .multisito-upload :deep(.p-card-body) {
    padding: 1rem;
  }
  .multisito-upload :deep(.p-card-content) {
    padding: 0;
  }
  .customer-summary {
    margin: 0.5rem 0 !important;
    padding: 0.75rem 0.5rem;
  }
  .customer-summary-grid {
    gap: 0.6rem;
    justify-content: stretch !important;
  }
  .customer-summary-card {
    flex: 1 1 calc(50% - 0.6rem);
    max-width: none;
    min-width: 0;
    margin: 0 !important;
    padding: 0.7rem;
    font-size: 0.82rem;
  }
  .customer-summary-card label {
    font-size: 0.78rem;
  }
  .customer-summary-card p {
    font-size: 0.82rem;
  }
}
@media screen and (max-width: 420px) {
  .customer-summary-card {
    flex-basis: 100%;
  }
}
</style>
